import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NbIconConfig } from '@nebular/theme';
import {
  Column,
  GridOption,
  ContextMenu,
  AngularGridInstance,
  FileType,
  Formatter,
  OnBeforeRowDetailToggleArgs,
  ExtensionName,
  FieldType,
  SlickEventData,
} from 'angular-slickgrid';
import { NbDialogService } from '@nebular/theme';
import {
  DiscrepanciaDTO,
  detallesDiscrepanciaSolucionadas,
  consultaDiscrepanciasDTO,
  detallesDiscrepancia,
  reportesDTO,
  consultaAveriasDTO,
} from '../entidades/entidades.component';
import { DatePipe } from '@angular/common';
import { AveriasService } from '../servicios/averias.service';
import { DateAdapter } from '@angular/material/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PerfilesUsuarioService } from '../servicios/perfiles-usuario.service';
import { Subscription } from 'rxjs';
import { DiscrepanciasActivasComponent } from '../discrepanciasActivas/discrepanciasActivas.component';
import { DiscrepanciasSolucionadasComponent } from '../discrepancias-solucionadas/discrepancias-solucionadas.component';
import { EditAveriaComponent } from '../edit-averia/edit-averia.component';
import { EditInspeccionAveriaComponent } from '../edit-inspeccion-averia/edit-inspeccion-averia.component';
import { SnackBarComponent } from '../snack-bar/snack-bar.component';
import { InspeccionesRowdetailComponent } from './inspecciones-rowdetail/inspecciones-rowdetail.component';
import { DialogoEliminarAveriasComponent } from 'src/app/dialogo-eliminar-averias/dialogo-eliminar-averias.component';
import { MatDialog } from '@angular/material/dialog';
import { jsPDF } from 'jspdf';
import { AnalyticsService } from '../servicios/analytics.service';

//import {SharedModule} from '../shared/shared.module';
import { OptionsReportesComponent } from '../options-reportes/options-reportes.component';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { NbTabsetModule } from '@nebular/theme';
import { NbSelectModule } from '@nebular/theme';
import { NbOptionModule } from '@nebular/theme';

import { AngularSlickgridModule } from 'angular-slickgrid';
//import { ExcelExportService } from 'angular-slickgrid';

import { NbDialogModule } from '@nebular/theme';
import { ReactiveFormsModule } from '@angular/forms';

import { ExcelExportService } from '@slickgrid-universal/excel-export';


import { AgGridAngular } from 'ag-grid-angular'; // Angular Data Grid Component
import type { ColDef, GridReadyEvent } from 'ag-grid-community'; // Column Definition Type Interface
import { GridOptions } from 'ag-grid-community';

import { VinsBuquesService } from '../servicios/vins-buques.service';
import { SelectItem } from 'primeng/api';

import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

import { GrillaColumns } from '../grilla-detalle/grilla-columns.components';
import { NbCheckboxModule } from '@nebular/theme';
import { NbToggleModule } from '@nebular/theme';
import type { GridApi, ColumnApiModule } from 'ag-grid-community';

export interface DialogData {
  vin: string;
}
@Component({
    selector: 'app-consulta-inspecciones',
    templateUrl: './consulta-inspecciones.component.html',
    styleUrls: ['./consulta-inspecciones.component.css'],
    standalone: true,
    imports: [OptionsReportesComponent,SpinnerComponent, 
      FormsModule,CommonModule,NbCardModule,NbIconModule,
      DropdownModule,MatCardModule,
      MatDatepickerModule,
      MatNativeDateModule,MatFormFieldModule,MatInputModule,NbTabsetModule,NbSelectModule,NbOptionModule,
      AngularSlickgridModule,
      NbDialogModule, ReactiveFormsModule, 
      AgGridAngular,
      NbCheckboxModule,
      NbToggleModule
     ],
     providers: [DatePipe],
     
})
export class ConsultaInspeccionesComponent implements OnInit {
   @ViewChild('grilla1') grilla1!: AgGridAngular;
   
   excelExportService: ExcelExportService;
  constructor(
    
    private dialogService: NbDialogService,
    private dateFormatter: DatePipe,
    private modalService: BsModalService,
    private adapter: DateAdapter<any>,
    private servicioAverias: AveriasService,
    public usersRol: PerfilesUsuarioService,
    private modalServiceBoostrap: NgbModal,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private svcAnalytics: AnalyticsService,
    private svcVinsBuq: VinsBuquesService
  ) {
    this.excelExportService = new ExcelExportService();
    

  }

  
  rowClassRules = GrillaColumns.rowClassRules;
  getRowHeight = GrillaColumns.getRowHeight;
  
  //#region variables
  @ViewChild('editAveria') private templateRefInspecciones: TemplateRef<any>;
  @ViewChild('editInspeccionAveria')
  private templateRefInspeccionesAveria: TemplateRef<any>;
  vin;
  idVinAveriaDelete;
  bellIconConfig: NbIconConfig = { icon: 'bell-outline', pack: 'eva' };
  detallesDatosAverias;
  cambiarGridOptions: boolean = false;
  durationInSeconds = 5;
  modalRef: BsModalRef;
  subscription: Subscription;
  idCliente: number;
  esCliente: string = 'false';
  idOperador: number;
  idTipoOperador: number;
  discrepancias: DiscrepanciaDTO[] = [];
  loadingResponse = false;
  // datasetConsultas: any[] = [];
  datasetConsultas: any = [];
  angularGrid: AngularGridInstance;
  dataView: any;
  showSpinner = false;
  showCards = false;
  showGrilla = false;
  bloqueoGenerar = true;
  bloqueoSinAverias = true;
  deshabilitarExportAverias = true;
  columnDefinitionsConsultas: ColDef[];
  //columnDefinitionsConsultas2 : ColDef[];
  rowData : any = [];
  gridOptionsConsultas: GridOption;
  showDiscrepancias = false;
  detallesActivas: detallesDiscrepancia;
  detalleAveria: any;
  detallesSolucionadas: detallesDiscrepanciaSolucionadas;
  estadoSolucionado = false;
  estadoActiva = false;
  reporteSelected: number = 0;
  vinSelected = '';
  pasarCedente: number;
  pasarReceptor: number;
  responseDataInspecciones: any = [];
  showContInsp: boolean = false;
  showExpo: boolean = false;
  showRepo: boolean = false;
  showtitle: boolean = false;
  mostrar = {
    buque: false,
    fechas: false,
    proceso: false,
    responsable: false,
    vin: false,
    procesosvisitas: false,
  };
  responsables;
  responsableSelected;
  buqueSelected;
  visitaSelected;
  fechaDesdeInspec = new Date();
  fechaHastaInspec = new Date();

  DesdeDiscrepancia = new Date();
  HastaDiscrepancia = new Date();
  deshabilitarBuscar = true;
  procesoSelected = '';
  deshabilitarBuscarConsulta = true;
  botonSinAveriasFlag = false;

  checkActiva: boolean = true;
  checkSolucionado: boolean = false;

  cantidadInspecciones: number = 0;
  cantidadAverias: number = 0;

  cantidadActivas: number = 0;
  cantidadSolucionadas: number = 0;

  filtrosReportes: reportesDTO;
  usarCheckbox=false;

  visitas = [];
  buquesVisita;
  // encontralo en vins-buques-modif.component.ts
  // buquesVisitaSeleccionado: visitaBuqueDTO = {
  //   idVisita: 0,
  //   idBuque:0,
  //   proceso: "",
  //   nombreBuque:"", 
  //   codVisitaExterno:"", 
  //   fechaArribo: null, 
  //   fechaPartida: null,
  //   etd: null,
  //   eta: null,
  //   ata: null,
  //   atd: null,
  //   idProceso : 0,
  //   codVerificacion: 0
  // };

//agregados:

  reportes: any[] = []; // Asegúrate de inicializarlo correctamente

  dataFiltered : any[] = [];



  buques = [];
 // reportes = [];
  procesos = [
    { Name: 'Importación', Codigo: 'importacion' },
    { Name: 'Exportación', Codigo: 'exportacion' },
    { Name: 'Mercado interno', Codigo: 'mercado interno' },
  ];

  procesosvisitas = [
    { Name: 'Importación', Codigo: 'importacion' },
    { Name: 'Exportación', Codigo: 'exportacion' },
  ];

  opcionesProceso = [
    { value: 'importacion', label: 'Importación' },
    { value: 'exportacion', label: 'Exportación' },
  ];

  filtrado: number = 0;

  detailViewRowCount: number = 2;
  idRow: number = null;
  //#endregion

  filasExpandidas = new Set<number>();

  ngOnInit(): void {
    this.adapter.setLocale('es-MX');
    this.idCliente = Number(localStorage.getItem('idCliente'));
    this.idOperador = Number(localStorage.getItem('idOperador'));
    var idTipoOp = localStorage.getItem('idTipoOperador');
    this.idTipoOperador = idTipoOp == 'null' ? 0 : Number(idTipoOp);
    this.esCliente = localStorage.getItem('esCliente');
    this.gestionReportes();
    this.cargarResponsables();
    this.cargarBuques();
    this.habilitarBotonBuscar();
    this.habilitarBotonBuscarConsultas();
    this.svcAnalytics.setAnalyticsPageView();
    this.usarCheckbox = true;
    this.getBuquesVisita();

  }

  gestionReportes() {
    //quieren que se pushen en distinto order por el tipo operador

    //Transporte
    if (this.idTipoOperador == 1) {
      if (this.usersRol.GESTIONAR_REPORTES_AVERIAS_RECEPCION_X_FECHA_PROCESO)
        //MODIFICAMOS EL NOMBRE DEL REPORTE INSPECCION POR AVERIAS
        this.reportes.push({ Name: 'Daños Recepción por proceso', Codigo: 7 });
      if (this.usersRol.GESTIONAR_REPORTES_AVERIAS_ENTREGA_X_FECHA_PROCESO)
        //MODIFICAMOS EL NOMBRE DEL REPORTE INSPECCION POR AVERIAS
        this.reportes.push({ Name: 'Daños Entrega por proceso', Codigo: 8 });
      if (this.usersRol.GESTIONAR_REPORTES_DANIOS_ASIGNADOS)
        this.reportes.push({ Name: 'Daños Asignados', Codigo: 14 });
      // AGREGAMOS 2 REPORTES NUEVOS SOLICITADOS EL 15/04/2021
      if (this.usersRol.GESTIONAR_REPORTES_INSPECCION_ENTREGA_FECHA_PROCESO)
        this.reportes.push({
          Name: 'Trazabilidad Recepción por proceso',
          Codigo: 9,
        });
      if (this.usersRol.GESTIONAR_REPORTES_INSPECCION_RECEPCION_FECHA_PROCESO)
        this.reportes.push({
          Name: 'Trazabilidad Entrega por proceso',
          Codigo: 10,
        });
      if (this.usersRol.GESTIONAR_REPORTES_DANIOS_RECHAZADOS)
        this.reportes.push({ Name: 'Daños Rechazados', Codigo: 15 });
      if (this.usersRol.GESTIONAR_REPORTES_TRAZABILIDAD_X_UNIDAD)
        this.reportes.push({ Name: 'Daños por VIN', Codigo: 6 });
    }
    //Naviera
    else if (this.idTipoOperador == 2) {
      // if (this.usersRol.GESTIONAR_REPORTES_PRELOAD)
      //   this.reportes.push({ Name: 'Daños Preload de Buques (Exportación)', Codigo: 1 })
      // if (this.usersRol.GESTIONAR_REPORTES_DESCARGA)
      //   this.reportes.push({ Name: 'Daños Descarga de Buques (Importación)', Codigo: 2 })
      if (this.usersRol.GESTIONAR_REPORTES_AVERIAS_RECEPCION_X_FECHA_PROCESO)
        //MODIFICAMOS EL NOMBRE DEL REPORTE INSPECCION POR AVERIAS
        this.reportes.push({ Name: 'Daños Recepción por proceso', Codigo: 7 });
      if (this.usersRol.GESTIONAR_REPORTES_AVERIAS_ENTREGA_X_FECHA_PROCESO)
        //MODIFICAMOS EL NOMBRE DEL REPORTE INSPECCION POR AVERIAS
        this.reportes.push({ Name: 'Daños Entrega por proceso', Codigo: 8 });
      if (this.usersRol.GESTIONAR_REPORTES_DANIOS_ASIGNADOS)
        this.reportes.push({ Name: 'Daños Asignados', Codigo: 14 });
      // AGREGAMOS 2 REPORTES NUEVOS SOLICITADOS EL 15/04/2021
      if (this.usersRol.GESTIONAR_REPORTES_INSPECCION_ENTREGA_FECHA_PROCESO)
        this.reportes.push({
          Name: 'Trazabilidad Recepción por proceso',
          Codigo: 9,
        });
      if (this.usersRol.GESTIONAR_REPORTES_INSPECCION_RECEPCION_FECHA_PROCESO)
        this.reportes.push({
          Name: 'Trazabilidad Entrega por proceso',
          Codigo: 10,
        });
      if (this.usersRol.GESTIONAR_REPORTES_DANIOS_RECHAZADOS)
        this.reportes.push({ Name: 'Daños Rechazados', Codigo: 15 });
      if (this.usersRol.GESTIONAR_REPORTES_TRAZABILIDAD_X_UNIDAD)
        this.reportes.push({ Name: 'Daños por VIN', Codigo: 6 });
    }
    // Playa
    else if (this.idTipoOperador == 3) {
      // if (this.usersRol.GESTIONAR_REPORTES_PRELOAD)
      //   this.reportes.push({ Name: 'Daños Preload de Buques (Exportación)', Codigo: 1 })
      // if (this.usersRol.GESTIONAR_REPORTES_DESCARGA)
      //   this.reportes.push({ Name: 'Daños Descarga de Buques (Importación)', Codigo: 2 })
      if (this.usersRol.GESTIONAR_REPORTES_AVERIAS_RECEPCION_X_FECHA_PROCESO)
        //MODIFICAMOS EL NOMBRE DEL REPORTE INSPECCION POR AVERIAS
        this.reportes.push({ Name: 'Daños Recepción por proceso', Codigo: 7 });
      if (this.usersRol.GESTIONAR_REPORTES_AVERIAS_ENTREGA_X_FECHA_PROCESO)
        //MODIFICAMOS EL NOMBRE DEL REPORTE INSPECCION POR AVERIAS
        this.reportes.push({ Name: 'Daños Entrega por proceso', Codigo: 8 });
      if (this.usersRol.GESTIONAR_REPORTES_DANIOS_ASIGNADOS)
        this.reportes.push({ Name: 'Daños Asignados', Codigo: 14 });
      // AGREGAMOS 2 REPORTES NUEVOS SOLICITADOS EL 15/04/2021
      if (this.usersRol.GESTIONAR_REPORTES_INSPECCION_ENTREGA_FECHA_PROCESO)
        this.reportes.push({
          Name: 'Trazabilidad Recepción por proceso',
          Codigo: 9,
        });
      if (this.usersRol.GESTIONAR_REPORTES_INSPECCION_RECEPCION_FECHA_PROCESO)
        this.reportes.push({
          Name: 'Trazabilidad Entrega por proceso',
          Codigo: 10,
        });
      // if (this.usersRol.GESTIONAR_REPORTES_DANIOS_SIN_CONFIRMAR)
      //   this.reportes.push({ Name: 'Daños sin Confirmar', Codigo: 13 })
      if (this.usersRol.GESTIONAR_REPORTES_DANIOS_RECHAZADOS)
        this.reportes.push({ Name: 'Daños Rechazados', Codigo: 15 });
      if (this.usersRol.GESTIONAR_REPORTES_TRAZABILIDAD_X_UNIDAD)
        this.reportes.push({ Name: 'Daños por VIN', Codigo: 6 });
    }
    // Puerto
    else if (this.idTipoOperador == 6) {
      // if (this.usersRol.GESTIONAR_REPORTES_PRELOAD)
      //   this.reportes.push({ Name: 'Daños Preload de Buques (Exportación)', Codigo: 1 })
      // if (this.usersRol.GESTIONAR_REPORTES_DESCARGA)
      //   this.reportes.push({ Name: 'Daños Descarga de Buques (Importación)', Codigo: 2 })
      if (this.usersRol.GESTIONAR_REPORTES_AVERIAS_RECEPCION_X_FECHA_PROCESO)
        //MODIFICAMOS EL NOMBRE DEL REPORTE INSPECCION POR AVERIAS
        this.reportes.push({ Name: 'Daños Recepción por proceso', Codigo: 7 });
      if (this.usersRol.GESTIONAR_REPORTES_AVERIAS_ENTREGA_X_FECHA_PROCESO)
        //MODIFICAMOS EL NOMBRE DEL REPORTE INSPECCION POR AVERIAS
        this.reportes.push({ Name: 'Daños Entrega por proceso', Codigo: 8 });
      if (this.usersRol.GESTIONAR_REPORTES_DANIOS_ASIGNADOS)
        this.reportes.push({ Name: 'Daños Asignados', Codigo: 14 });
      // AGREGAMOS 2 REPORTES NUEVOS SOLICITADOS EL 15/04/2021
      if (this.usersRol.GESTIONAR_REPORTES_INSPECCION_ENTREGA_FECHA_PROCESO)
        this.reportes.push({
          Name: 'Trazabilidad Recepción por proceso',
          Codigo: 9,
        });
      if (this.usersRol.GESTIONAR_REPORTES_INSPECCION_RECEPCION_FECHA_PROCESO)
        this.reportes.push({
          Name: 'Trazabilidad Entrega por proceso',
          Codigo: 10,
        });
      if (this.usersRol.GESTIONAR_REPORTES_DANIOS_RECHAZADOS)
        this.reportes.push({ Name: 'Daños Rechazados', Codigo: 15 });
      if (this.usersRol.GESTIONAR_REPORTES_TRAZABILIDAD_X_UNIDAD)
        this.reportes.push({ Name: 'Daños por VIN', Codigo: 6 });
      if (this.usersRol.GESTIONAR_REPORTES_TRAZABILIDAD_X_UNIDAD)
        this.reportes.push({ Name: 'Daños por Visita', Codigo: 19 });
    }
    //Concesionario
    else if (this.idTipoOperador == 4) {
      if (this.usersRol.GESTIONAR_REPORTES_AVERIAS_RECEPCION_X_FECHA)
        this.reportes.push({ Name: 'Daños Recepción', Codigo: 11 });
      if (this.usersRol.GESTIONAR_REPORTES_AVERIAS_ENTREGA_X_FECHA)
        this.reportes.push({ Name: 'Daños Entrega', Codigo: 12 });
      if (this.usersRol.GESTIONAR_REPORTES_DANIOS_ASIGNADOS)
        this.reportes.push({ Name: 'Daños Asignados', Codigo: 14 });
      if (this.usersRol.GESTIONAR_REPORTES_TRAZABILIDAD_RECEPCION)
        this.reportes.push({ Name: 'Trazabilidad Recepción', Codigo: 17 });
      if (this.usersRol.GESTIONAR_REPORTES_TRAZABILIDAD_ENTREGA)
        this.reportes.push({ Name: 'Trazabilidad Entrega', Codigo: 18 });
      if (this.usersRol.GESTIONAR_REPORTES_DANIOS_RECHAZADOS)
        this.reportes.push({ Name: 'Daños Rechazados', Codigo: 15 });
      if (this.usersRol.GESTIONAR_REPORTES_TRAZABILIDAD_X_UNIDAD)
        this.reportes.push({ Name: 'Daños por VIN', Codigo: 6 });
    }
    //Planta Mercado Local  y Exportación
    else if (this.idTipoOperador == 8 || this.idTipoOperador == 5) {
      if (this.usersRol.GESTIONAR_REPORTES_AVERIAS_X_FECHA)
        this.reportes.push({ Name: 'Daños por proceso', Codigo: 4 });
      if (this.usersRol.GESTIONAR_REPORTES_PROFORMA)
        this.reportes.push({ Name: 'Daños por responsable', Codigo: 5 });
      //MODIFICAMOS EL NOMBRE DEL REPORTE INSPECCION POR AVERIAS
      if (this.usersRol.GESTIONAR_REPORTES_AVERIAS_X_FECHA_INTEGRAL)
        this.reportes.push({
          Name: 'Daños por proceso y responsable',
          Codigo: 3,
        });
      if (this.usersRol.GESTIONAR_REPORTES_PRELOAD)
        this.reportes.push({
          Name: 'Daños Preload de Buques (Exportación)',
          Codigo: 1,
        });
      if (this.usersRol.GESTIONAR_REPORTES_DESCARGA)
        this.reportes.push({
          Name: 'Daños Descarga de Buques (Importación)',
          Codigo: 2,
        });
      if (this.usersRol.GESTIONAR_REPORTES_TRAZABILIDAD_X_UNIDAD)
        this.reportes.push({ Name: 'Daños por VIN', Codigo: 6 });
      if (this.usersRol.GESTIONAR_REPORTES_TRAZABILIDAD_POR_PROCESO)
        this.reportes.push({ Name: 'Trazabilidad por Proceso', Codigo: 16 });
      if (this.usersRol.GESTIONAR_REPORTES_DANIOS_SIN_CONFIRMAR)
        this.reportes.push({ Name: 'Daños sin Confirmar', Codigo: 13 });
      // if (this.usersRol.GESTIONAR_REPORTES_AVERIAS_RECEPCION_X_FECHA)
      this.reportes.push({ Name: 'Daños Recepción', Codigo: 11 });
      if (this.usersRol.GESTIONAR_REPORTES_AVERIAS_ENTREGA_X_FECHA)
        this.reportes.push({ Name: 'Daños Entrega', Codigo: 12 });
      if (this.usersRol.GESTIONAR_REPORTES_DANIOS_RECHAZADOS)
        this.reportes.push({ Name: 'Daños Rechazados', Codigo: 15 });
      if (this.usersRol.GESTIONAR_REPORTES_DANIOS_ASIGNADOS)
        this.reportes.push({ Name: 'Daños Asignados', Codigo: 14 });
      if (this.usersRol.GESTIONAR_REPORTES_AVERIAS_RECEPCION_X_FECHA_PROCESO)
        //MODIFICAMOS EL NOMBRE DEL REPORTE INSPECCION POR AVERIAS
        this.reportes.push({ Name: 'Daños Recepción por proceso', Codigo: 7 });
      if (this.usersRol.GESTIONAR_REPORTES_AVERIAS_ENTREGA_X_FECHA_PROCESO)
        //MODIFICAMOS EL NOMBRE DEL REPORTE INSPECCION POR AVERIAS
        this.reportes.push({ Name: 'Daños Entrega por proceso', Codigo: 8 });
      if (this.usersRol.GESTIONAR_REPORTES_TRAZABILIDAD_RECEPCION)
        this.reportes.push({ Name: 'Trazabilidad Recepción', Codigo: 17 });
      if (this.usersRol.GESTIONAR_REPORTES_TRAZABILIDAD_ENTREGA)
        this.reportes.push({ Name: 'Trazabilidad Entrega', Codigo: 18 });
      if (this.usersRol.GESTIONAR_REPORTES_INSPECCION_ENTREGA_FECHA_PROCESO)
        this.reportes.push({
          Name: 'Trazabilidad Recepción por proceso',
          Codigo: 9,
        });
      if (this.usersRol.GESTIONAR_REPORTES_INSPECCION_RECEPCION_FECHA_PROCESO)
        this.reportes.push({
          Name: 'Trazabilidad Entrega por proceso',
          Codigo: 10,
        });
    }
    //Cliente
    else {
      //MODIFICAMOS EL NOMBRE DEL REPORTE INSPECCION POR AVERIAS
      if (this.usersRol.GESTIONAR_REPORTES_AVERIAS_X_FECHA)
        this.reportes.push({ Name: 'Daños por proceso', Codigo: 4 });
      if (this.usersRol.GESTIONAR_REPORTES_PROFORMA)
        this.reportes.push({ Name: 'Daños por responsable', Codigo: 5 });
      //MODIFICAMOS EL NOMBRE DEL REPORTE INSPECCION POR AVERIAS
      if (this.usersRol.GESTIONAR_REPORTES_AVERIAS_X_FECHA_INTEGRAL)
        this.reportes.push({
          Name: 'Daños por proceso y responsable',
          Codigo: 3,
        });
      // if (this.usersRol.GESTIONAR_REPORTES_PRELOAD)
      //   this.reportes.push({ Name: 'Daños Preload de Buques (Exportación)', Codigo: 1 })
      // if (this.usersRol.GESTIONAR_REPORTES_DESCARGA)
      //   this.reportes.push({ Name: 'Daños Descarga de Buques (Importación)', Codigo: 2 })
      if (this.usersRol.GESTIONAR_REPORTES_TRAZABILIDAD_X_UNIDAD)
        this.reportes.push({ Name: 'Daños por VIN', Codigo: 6 });
      if (this.usersRol.GESTIONAR_REPORTES_TRAZABILIDAD_POR_PROCESO)
        this.reportes.push({ Name: 'Trazabilidad por Proceso', Codigo: 16 });
      if (this.usersRol.GESTIONAR_REPORTES_DANIOS_SIN_CONFIRMAR)
        this.reportes.push({ Name: 'Daños sin Confirmar', Codigo: 13 });
      // if (this.usersRol.GESTIONAR_REPORTES_AVERIAS_RECEPCION_X_FECHA)
      //   this.reportes.push({ Name: 'Daños Recepción', Codigo: 11 })
      // if (this.usersRol.GESTIONAR_REPORTES_AVERIAS_ENTREGA_X_FECHA)
      //   this.reportes.push({ Name: 'Daños Entrega', Codigo: 12 })
      if (this.usersRol.GESTIONAR_REPORTES_DANIOS_RECHAZADOS)
        this.reportes.push({ Name: 'Daños Rechazados', Codigo: 15 });
      if (this.usersRol.GESTIONAR_REPORTES_TRAZABILIDAD_X_UNIDAD)
        this.reportes.push({ Name: 'Daños por Visita', Codigo: 19 });
      // if (this.usersRol.GESTIONAR_REPORTES_DANIOS_ASIGNADOS)
      //   this.reportes.push({ Name: 'Daños Asignados', Codigo: 14 })
      // if (this.usersRol.GESTIONAR_REPORTES_AVERIAS_RECEPCION_X_FECHA_PROCESO)
      //   //MODIFICAMOS EL NOMBRE DEL REPORTE INSPECCION POR AVERIAS
      //   this.reportes.push({ Name: 'Daños Recepción por proceso', Codigo: 7 })
      // if (this.usersRol.GESTIONAR_REPORTES_AVERIAS_ENTREGA_X_FECHA_PROCESO)
      //   //MODIFICAMOS EL NOMBRE DEL REPORTE INSPECCION POR AVERIAS
      //   this.reportes.push({ Name: 'Daños Entrega por proceso', Codigo: 8 })
      // if (this.usersRol.GESTIONAR_REPORTES_TRAZABILIDAD_RECEPCION)
      //   this.reportes.push({ Name: 'Trazabilidad Recepción', Codigo: 17 })
      // if (this.usersRol.GESTIONAR_REPORTES_TRAZABILIDAD_ENTREGA)
      //   this.reportes.push({ Name: 'Trazabilidad Entrega', Codigo: 18 })
      // if (this.usersRol.GESTIONAR_REPORTES_INSPECCION_ENTREGA_FECHA_PROCESO)
      //   this.reportes.push({ Name: 'Trazabilidad Recepción por proceso', Codigo: 9 })
      // if (this.usersRol.GESTIONAR_REPORTES_INSPECCION_RECEPCION_FECHA_PROCESO)
      //   this.reportes.push({ Name: 'Trazabilidad Entrega por proceso', Codigo: 10 })
    }
    //console.log(this.reportes);
  }
  buscarDiscrepancias() {
    this.showCards = true;
    this.discrepancias = [];
    var objDiscrepancia: consultaDiscrepanciasDTO;
    this.cantidadActivas = 0;
    this.cantidadSolucionadas = 0;
    var activoVal = null;
    if (this.checkActiva == true && this.checkSolucionado == true)
      activoVal = null;
    else if (this.checkActiva == true && this.checkSolucionado == false)
      activoVal = true;
    else if (this.checkActiva == false && this.checkSolucionado == true)
      activoVal = false;

    objDiscrepancia = {
      idCliente: this.idCliente,
      proceso: this.procesoSelected,
      // fechaDesde: this.DesdeDiscrepancia,
      // fechaHasta:this.HastaDiscrepancia,
      fechaDesde:
        this.dateFormatter.transform(this.DesdeDiscrepancia, 'yyyy-MM-ddT') +
        '00:00:00',
      fechaHasta:
        this.dateFormatter.transform(this.HastaDiscrepancia, 'yyyy-MM-ddT') +
        '23:59:59',
      activo: activoVal,
    };
    this.servicioAverias
      .ListaDiscrepancias(objDiscrepancia)
      .subscribe((data) => {
        var discrepancia: DiscrepanciaDTO;
        var resp = data;
        resp.forEach((element) => {
          discrepancia = {
            id: element['id'],
            cedente: element['cedente'],
            receptor: element['receptor'],
            activo: element['activo'],
            estado: element['activo'] == true ? 'Activa' : 'Solucionada',
            //version antigua del daf
            // solucionada: element["inspeccionVinAveria"] == null ? false : true,
            //se parchea temporalmete
            // solucionada: element["inspeccionVinAveria"].fecha == element["vinAveria"].fecha ? false : true,
            //parche final averiaSimilar es null pantalla editar solucionar
            //Si averiaSimilar <>null  pantalla de los solucionados y marcada la averia similar
            // solucionada: element["inspeccionVinAveria"].averiaSimilar == null ? false : true,
            //DESCOMENTAR ESTO SI QUIEREN VER SOLUCIONADAS
            // solucionada: element["activo"] == true ? false : true,
            //ULTIMA VERSION, SE TOMA EL CAMPO TIPO ASOCIACION PARA SABER QUE PANTALLA MOSTRAR
            solucionada:
              element['inspeccionVinAveria'].tipoAsociacion == 3 ? false : true,
            comentario:
              element['comentario'] == null
                ? 'Sin comentario'
                : element['comentario'],
            vinAveria: element['vinAveria'],
            inspeccionVinAveria: element['inspeccionVinAveria'],
            //agrego comentarioAveria. O es asi? element.vinAveria["comentarioModificacion"],
            comentarioModificacion:
              element['comentarioAveria'] == null
                ? ''
                : element['comentarioAveria'],
          };
          this.discrepancias.push(discrepancia);
        });
        this.cantidadActivas = this.discrepancias.filter(
          (n) => n.activo == true
        ).length;
        this.cantidadSolucionadas = this.discrepancias.filter(
          (n) => n.activo == false
        ).length;
        this.showCards = false;
        //gtag botón de búsqueda
        this.svcAnalytics.setAnalyticsSearchButton();
      });
  }
  changeEstadoActiva() {
    this.habilitarBotonBuscar();
  }
  changeEstadoSolucionado() {
    this.habilitarBotonBuscar();
  }
  changeDesdeDiscrepancia(event: any) {
    this.habilitarBotonBuscar();
  }
  changeHastaDiscrepancia(event: any) {
    this.habilitarBotonBuscar();
  }
  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.dataView = angularGrid.dataView;
    this.angularGrid.resizerService.pauseResizer(false);

  }

  get rowDetailInstance(): any {
    // return this.angularGrid && this.angularGrid.extensionService.getSlickgridAddonInstance(ExtensionName.rowDetailView) || {}; // version 2.32.2
    // return this.angularGrid?.extensionService.getExtensionInstanceByName(ExtensionName.rowDetailView) || {}; // option 2
    return this.angularGrid.extensions.rowDetailView.instance || {};
  }

  onFiltroAplicado(event: any) {
  // console.log('Filtro aplicado');

  // // Ejecutás tus funciones específicas
  // const expandColumn = GrillaColumns.getExpandColumn(this.filasExpandidas,this);
  // const detalleColumn = GrillaColumns.getDetalleColumn();

  // // Por ejemplo, podrías actualizar el estado o reinyectar columnas
  // // aunque usualmente las columnas ya están cargadas
  // console.log('expandColumn', expandColumn);
  // console.log('detalleColumn', detalleColumn);


  //  this.grilla1.api.forEachNode((node) => {
  //   if (this.filasExpandidas.has(node.data.id)) {
  //     const row = node.data;
  //     const index = node.rowIndex ?? 0;
  //     const detailRow = {
  //       ...row,
  //       isDetail: true,
  //       parentId: row.id,
  //       detailData: row.datosAverias,
  //     };
  //     this.grilla1.api.applyTransaction({ add: [detailRow], addIndex: index + 1 });
  //     row.isExpanded = true;
  //   }
  // });
}




  refreshMetrics(event: any) {
  if (event && event.api) {

    const displayedRowCount = this.grilla1.api.getDisplayedRowCount();
    const currentCount = displayedRowCount;
   // this.grilla1.columnDefs = this.columnDefinitionsConsultas;
    //this.dataFiltered = this.grilla1.api.ge
      this.dataFiltered = [];
    this.grilla1.api.forEachNodeAfterFilterAndSort((node) => {
      if (node.data) this.dataFiltered.push(node.data);
    });

        if (this.reporteSelected == 10 || this.responsableSelected == 9) {
          if (this.cantidadInspecciones == currentCount) this.filtrado = 0;
          else this.filtrado = currentCount;
        } else {
          if (this.cantidadInspecciones == currentCount) this.filtrado = 0;
          else this.filtrado = currentCount
        }

  }
}

/*
  refreshMetrics(args) {
    if (args && args.current >= 0) {
      setTimeout(() => {
        this.dataFiltered = args.dataView.getFilteredItems();
        if (this.reporteSelected == 10 || this.responsableSelected == 9) {
          if (this.cantidadInspecciones == args.current) this.filtrado = 0;
          else this.filtrado = args.current;
        } else {
          if (this.cantidadInspecciones == args.current) this.filtrado = 0;
          else this.filtrado = args.current;
        }
      });
    }
  }
*/


  cargarResponsables() {
    this.servicioAverias
      .getOperadoresPorCliente(this.idCliente)
      .subscribe((data) => {
        this.responsables = data;
      });
  }
  cargarBuques() {
    this.servicioAverias.getBuques().subscribe((data) => {
      this.buques = data['content'];
    });
  }

  // Cambia la cantidad de lineas dinamicamente segun las averias que tenga cada vin
  changeDetailViewRowCount(item: any) {
    if (this.angularGrid && this.angularGrid.extensionService) {
      this.detailViewRowCount = item.datosAverias.length + 2;
      const options = this.rowDetailInstance.getOptions();
      if (options && options.panelRows && this.detailViewRowCount < 8) {
        options.panelRows = this.detailViewRowCount;
        this.rowDetailInstance.setOptions(options);
      } else {
        options.panelRows = 8;
        this.rowDetailInstance.setOptions(options);
      }
    }
  }

  getBuquesVisita(){
    //getBuquesVisitaAbiertas
    this.svcVinsBuq.getBuquesVisitaTodos(this.idCliente).subscribe(
      data => {
        this.buquesVisita = data;
        this.insertarBuquesVisita(this.buquesVisita);
      })
  }

  insertarBuquesVisita(arg) {
    this.visitas = [];
    arg.forEach(element => {
      this.visitas.push({
        idbuque: element.idBuque,
        descripcion: element.nombreBuque + " - " + element.codVisitaExterno,
        Codigo: element.codVisitaExterno,//+ ";" + element.idBuque,
      });
    })
  }

  ngAfterViewInit() {
    // Ya podés usar la API acá
    // this.grilla1.api.sizeColumnsToFit();
  }

  expandirFilasConDetalle() {
  this.grilla1.api.forEachNode((node) => {
    if (node.data?.datosAverias?.length > 0) {
      node.setExpanded(true);
    }
  });
}


  // grilla-columns.component.ts
  mostrarPopup = false;
  popupTitulo = '';
  popupBody = '';

  cerrarPopup() {
    this.mostrarPopup = false;
  }



   onGridReady(params: GridReadyEvent): void {
   
      // this.expandirFilasConDetalle();

      this.grilla1.api.redrawRows();

       params.api.forEachNode((node) => {
         var data = node.data;
           const allRows: any[] = [];

       });

      this.grilla1.api.addEventListener('filterChanged', () => {
        // this.grilla1.api,
        this.restaurarFilasExpandidas(this.grilla1.api, this.filasExpandidas );
      });

      this.grilla1.api.addEventListener('sortChanged', () => {
        this.restaurarFilasExpandidas(this.grilla1.api, this.filasExpandidas );
      });

    }


    onFilterChanged(event: any) {
      // event.api para la API
      const nuevasFilasDetalle = [];

      this.grilla1.api.forEachNodeAfterFilter((node) => {
      if (this.filasExpandidas.has(node.data.id) && !node.data.isDetail) {
        nuevasFilasDetalle.push({
          isDetail: true,
          parentId: node.data.id,
          detailData: node.data.datosAverias
          });
        }
      });
      // this.grilla1.api.forEachNodeAfterFilter((node) => {
      //   if (!node.data?.isDetail && this.filasExpandidas.has(node.data.id)) {
      //     nuevasFilasDetalle.push({
      //       isDetail: true,
      //       parentId: node.data.id,
      //       detailData: node.data.datosAverias
      //     });
      //   }
      // });

      if (nuevasFilasDetalle.length>0) {
        this.grilla1.api.applyTransaction({ add: nuevasFilasDetalle });
        this.grilla1.api.redrawRows(); // Forzar render completo
      }



    }


restaurarFilasExpandidas(api: any, filasExpandidas: Set<number>) {


     api.redrawRows(); // Forzar render completo


  // const nuevasFilas = [];
  
  // api.forEachNodeAfterFilter((node) => {
  //   if (filasExpandidas.has(node.data.id) && !node.data.isDetail) {
  //     nuevasFilas.push({
  //       isDetail: true,
  //       parentId: node.data.id,
  //       detailData: node.data.datosAverias
  //     });
  //   }
  // });

  //       api.applyTransaction({
  //             add: nuevasFilas,
  //             addIndex: 1,
  //           });

  // if (nuevasFilas.length) {
  //   api.applyTransaction({ add: nuevasFilas });
  // }

}


reinsertarFilasDetalle() {
  // Eliminar todas las filas detalle existentes primero
  const allRows: any[] = [];
  this.grilla1.api.forEachNode((node) => allRows.push(node.data));

  const detailRows = allRows.filter(r => r.isDetail);
  if (detailRows.length > 0) {
    this.grilla1.api.applyTransaction({ remove: detailRows });
  }

  // Insertar filas detalle solo para filas filtradas y expandidas
  this.grilla1.api.forEachNodeAfterFilter((node) => {
    const row = node.data;
    if (row && this.filasExpandidas.has(row.id)) {
      const index = node.rowIndex ?? 0;
      this.grilla1.api.applyTransaction({
        add: [{
          isDetail: true,
          parentId: row.id,
          detailData: row.datosAverias,
        }],
        addIndex: index + 1
      });
      row.isExpanded = true;
    }
  });
}



/*
reinsertarFilasDetalle() {
  const detallesParaEliminar: any[] = [];


  this.grilla1.api.forEachNode((node) => {
    if (node.data.datosAverias.length > 0) {
      detallesParaEliminar.push(node.data);
    }
  });

  const rowsToAdd: any[] = [];

  this.grilla1.api.forEachNodeAfterFilterAndSort((node, index) => {
    const data = node.data;
    if (!data || data.isDetail) return;

      const detailRow = {
        id: `detail-${data.id}`,
        isDetail: true,
        parentId: data.id,
        detailData: data.datosAverias,
      };
      rowsToAdd.push({ row: detailRow, index: index + 1 });
 
  });

  rowsToAdd.forEach(r => {
    this.grilla1.api.applyTransaction({
      add: [r.row],
      addIndex: r.index,
    });
  });
}

*/


  // grid: any;

  // onAngularGridCreated(grid: AngularGridInstance) {
  //   this.angularGrid = grid;
  //   this.grid = grid.slickGrid;
  //   this.dataView = grid.dataView;
  // }


detailCellRendererParams = {
  detailGridOptions: {
    columnDefs: [

    ], // columnas del detalle
    // otras configuraciones del grid detalle si las necesitás
  },
  getDetailRowData: (params) => {
    const item = params.data;
    if (item.id !== this.idRow) {
      this.idRow = item.id;
      this.changeDetailViewRowCount(item); // tu lógica
    }

    // Llamás a la función asincrónica
    this.buscarInspeccionesAveriaOperador(item).then((detalle) => {
      params.successCallback(detalle);
    });
  },
  suppressRefresh: true, // para que no recargue innecesariamente
};

  
  armarColumnas() {
    this.botonSinAveriasFlag == false;
    if (this.cambiarGridOptions == true) {
      this.gridOptionsConsultas = {
        enableAutoResize: true,
        enableGridMenu: false,
        enableSorting: true,
        enableCellNavigation: true,
       enableCellMenu: true,
        enableContextMenu: false,
        enableExcelExport: true,
        excelExportOptions: {
          exportWithFormatter: false,
        },
        enableFiltering: true,
        rowSelectionOptions: { selectActiveRow: false },
        enableRowDetailView: true, // activa desactiva el detalle de la linea
        
        rowDetailView: {
          process: (item) => this.buscarInspeccionesAveriaOperador(item),
          loadOnce: true,
          singleRowExpand: true,
          useRowClick: false,
          panelRows: 7,
          // panelRows: this.detailViewRowCount,
          expandableOverride: (row: number, dataContext: any) =>
            dataContext.datosAverias?.length >= 1,
          // onBeforeRowDetailToggle: (e: SlickEventData<any>, args: OnBeforeRowDetailToggleArgs) => {
          //   const item = args.item;
          //   if (item.id === this.idRow) return;
          //   this.idRow = item.id;
          //   this.changeDetailViewRowCount(item);
            onBeforeRowDetailToggle: (e, args) => {
            const item = args.item;
            if (item.id === this.idRow) return;
            this.idRow = item.id;
            this.changeDetailViewRowCount(item);
          },

          viewComponent: InspeccionesRowdetailComponent,
        },
      };
    } else {
  
      this.gridOptionsConsultas = {
        enableAutoResize: true,
        enableGridMenu: false,
        enableSorting: true,
        enableCellNavigation: true,
        enableCellMenu: true,
        enableContextMenu: false,
        //enableExport: false,
        enableExcelExport: true,
        excelExportOptions: {
          exportWithFormatter: false,
        },
        enableFiltering: true,
        rowSelectionOptions: { selectActiveRow: false },
        enableRowSelection: false,
      };
    }
    this.columnsDefinitionsSegunTipoUsuario();
    this.seleccionarMetodoReportes();
    //gtag botón de búsqueda
    this.svcAnalytics.setAnalyticsSearchButton();
  }
  seleccionarMetodoReportes() {
    if (
      this.reporteSelected == 7 ||
      this.reporteSelected == 8 ||
      this.reporteSelected == 11 ||
      this.reporteSelected == 12 ||
      this.reporteSelected == 13 ||
      this.reporteSelected == 14 ||
      this.reporteSelected == 15
    ) {
      this.buscarInspeccionAveria();
    } else if (
      this.reporteSelected == 9 ||
      this.reporteSelected == 10 ||
      this.reporteSelected == 16 ||
      this.reporteSelected == 17 ||
      this.reporteSelected == 18
    ) {
      this.buscarInspeccionAveriaOperador();
    } else if (this.reporteSelected == 6) {
      this.buscarAveriasPorVin();
    } else {
      this.buscarAverias();
    }
  }

  exportToExcelAverias() {
    if (this.cambiarGridOptions == true) {
      if (this.angularGrid && this.angularGrid.extensionService) {
        // this.rowDetailInstance.collapse();
        this.rowDetailInstance.collapseAll();
      }
    }
    if (this.reporteSelected == 16) {
      //this.exportToExcel();
      this.exportToExcelTrazabilidad();
    } else {
      var nombreReporte = this.reportes.find(
        (n) => n.Codigo == this.reporteSelected
      );
    
    //   this.grilla1.api.exportDataAsCsv({
    //   fileName: 'grilla1.csv',
    //   columnSeparator: ';',
    //   allColumns: true,
 
    // });


      this.exportToExcelConXLSX(); 

      this.svcAnalytics.setAnalyticsExcelButton();
    }
  }


exportToExcelConXLSX(): void {
  const rowData: any[] = [];
 const columnasVisibles = this.grilla1.api.getAllDisplayedColumns();

  // Obtener solo las filas visibles (después de filtros y orden)
  this.grilla1.api.forEachNodeAfterFilterAndSort((node) => {
    if (node.data) {
      const filaFiltrada: any = {};

      // Solo columnas visibles
      columnasVisibles.forEach(col => {
        const campo = col.getColDef().field;
        if (campo && campo!='action') {
          filaFiltrada[campo] = node.data[campo];
        }
      });
      rowData.push(filaFiltrada);
    }
  });

  if (rowData.length === 0) {
    console.warn('No hay datos para exportar');
    return;
  }

  const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rowData);
  const workbook: XLSX.WorkBook = {
    Sheets: { 'Inspecciones': worksheet },
    SheetNames: ['Inspecciones']
  };

  const excelBuffer: any = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array'
  });

  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  FileSaver.saveAs(blob, 'Inspecciones_' + this.dateFormatter.transform(new Date(), 'dd-MM-yyyy') + '.xlsx');
}


exportToExcelTrazabilidad(): void {
  const rowData: any[] = [];
  const columnasVisibles = this.grilla1.api.getAllDisplayedColumns();

  // Obtener solo las filas visibles (después de filtros y orden)
  this.grilla1.api.forEachNodeAfterFilterAndSort((node) => {
    if (node.data) {
      const filaFiltrada: any = {};

      // Solo columnas visibles (sin 'action')
      columnasVisibles.forEach(col => {
        const campo = col.getColDef().field;
        if (campo && campo !== 'action' && campo !== 'expand' && campo !== 'details'){
          filaFiltrada[campo] = node.data[campo];
        }
      });

      
      if (node.data.datosAverias && node.data.datosAverias.length > 0) {
        for (let i = 0; i < node.data.datosAverias.length; i++) {
          const averia = node.data.datosAverias[i];
          const info = `Daño: ${averia.tipo} - ${averia.areaZonaCuadrante} - ${averia.severidad} | Responsable: ${averia.responsable} | Clasificación: ${averia.clasificacion} | Observación: ${averia.observacion}`;
          filaFiltrada['Averia ' + (i + 1)] = info;
        }
      }

      rowData.push(filaFiltrada);
    }
  });

  if (rowData.length === 0) {
    console.warn('No hay datos para exportar');
    return;
  }

  const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rowData);
  const workbook: XLSX.WorkBook = {
    Sheets: { 'Trazabilidad': worksheet },
    SheetNames: ['Trazabilidad']
  };

  const excelBuffer: any = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array'
  });

  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  FileSaver.saveAs(blob, 'Trazabilidad por Proceso.xlsx');
}



// exportToExcelTrazabilidad(): void {
//   const rowData: any[] = [];
//  const columnasVisibles = this.grilla1.api.getAllDisplayedColumns();


 
//   // Obtener solo las filas visibles (después de filtros y orden)
//   this.grilla1.api.forEachNodeAfterFilterAndSort((node) => {
//     if (node.data) {
//       const filaFiltrada: any = {};

//       // Solo columnas visibles
//       columnasVisibles.forEach(col => {
//         const campo = col.getColDef().field;
//         if (campo && campo!='action') {
//           filaFiltrada[campo] = node.data[campo];
//         }
//       });
//       rowData.push(filaFiltrada);
//     }
//   });

//   if (rowData.length === 0) {
//     console.warn('No hay datos para exportar');
//     return;
//   }

//   const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rowData);
//   const workbook: XLSX.WorkBook = {
//     Sheets: { 'Trazabilidad': worksheet },
//     SheetNames: ['Trazabilidad']
//   };

//   const excelBuffer: any = XLSX.write(workbook, {
//     bookType: 'xlsx',
//     type: 'array'
//   });

//   const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
//   FileSaver.saveAs(blob, 'Trazabilidad por Proceso.xlsx');
// }
  
  exportToExcel() {
    //console.log(this.datasetConsultas);
    let data = this.datasetConsultas.map((e) => {
      let obj = {
        Vin: e.vin,
        Modelo: e.modelo,
        'Fecha Inspección': e.fechaInspeccion,
        Proceso: e.proceso,
        Cedente: e.cedente,
        Receptor: e.receptor,
        Identificador: e.identificador,
        Averias: e.averia,
      };
      if (e.datosAverias.length > 0) {
        for (let i = 0; i < e.datosAverias.length; i++) {
          let averia = e.datosAverias[i];
          let info = `Daño: ${averia.tipo} - ${averia.areaZonaCuadrante} - ${averia.severidad} | Responsable: ${averia.responsable} | Clasificación: ${averia.clasificacion} | Observación: ${averia.observacion} | `;
          obj['Averia ' + (i + 1)] = info;
        }
      }
      return obj;
    });
    //console.log(data);
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'Trazabilidad por Proceso.xlsx');
  }

  openPopupEliminarAveria(data) {
    this.vin = data.vin;
    this.idVinAveriaDelete = data.id;
    const dialogRef = this.dialog.open(DialogoEliminarAveriasComponent, {
      width: '600px',
      height: '200px',
      data: { vin: this.vin },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.deleteAverias();
      }
    });
  }
  deleteAverias() {
    this.servicioAverias
      .deleteAverias(this.idVinAveriaDelete)
      .subscribe((data) => {
        if (data['status'] == 204) {
          this.openSnackBar('La avería se ha eliminado correctamente');
          this.buscarAverias();
        } else {
          this.openSnackBar('Ha ocurrido un error al eliminar los datos');
        }
      });
  }
  buscarAveriasPorVin() {
    let filtro: consultaAveriasDTO;
    this.showSpinner = true;
    this.showGrilla = false;
    this.bloqueoGenerar = true;
    this.bloqueoSinAverias = true;
    this.deshabilitarExportAverias = true;

    filtro = {
      receptor:
        this.esCliente == 'true'
          ? this.mostrar.responsable == false
            ? null
            : [Number(this.responsableSelected)]
          : [this.idOperador],
      cedente: [],
      fechaDesdeInspeccion:
        this.mostrar.fechas == false
          ? null
          : this.dateFormatter.transform(this.fechaDesdeInspec, 'yyyy-MM-ddT') +
            '00:00:00',
      fechaHastaInspeccion:
        this.mostrar.fechas == false
          ? null
          : this.dateFormatter.transform(this.fechaHastaInspec, 'yyyy-MM-ddT') +
            '23:59:00',
      //cambiamos esta busqueda para que si estas logueado como operador solo puedas ver tus averias
      //y si estas como cliente puedas ver todas.
      responsable: [],
      // responsable: this.mostrar.responsable == false ? null : [Number(this.responsableSelected)],
      proceso: this.mostrar.proceso == false ? null : this.procesoSelected,
      vin: this.mostrar.vin == false ? null : this.vinSelected, //quizas tiene que hacer aca el chequeo de que existe el vin para generar el pdf sin averias
      transporte:
        this.mostrar.buque == false
          ? null
          : this.reporteSelected == 2
          ? this.buqueSelected
          : null,
      transporteReceptor:
        this.mostrar.buque == false
          ? null
          : this.reporteSelected == 1
          ? this.buqueSelected
          : null,
      idCliente: this.idCliente,
      idTipoReporte: this.reporteSelected,
      codigoVisitaExterna: null,
      idbuque: null
    };
    if (this.fechaDesdeInspec <= this.fechaHastaInspec) {
      this.cantidadAverias = 0;
      this.filtrado = 0;
      this.cantidadInspecciones = 0;
      this.servicioAverias.getAveriasPorVin(filtro).subscribe(
        (data) => {
          //console.log(data);
          if (data['status'] == 200) {
            this.showSpinner = false;
            this.showGrilla = true;
            if (data.body.length > 0) {
              let mockDataset: any = [];
              for (let i = 0; i < data.body.length; i++) {
                mockDataset.push({
                  areaComponente: data.body[i].areaComponente,
                  // fecha: data.body[i].fecha,
                  fecha: this.dateFormatter.transform(
                    data.body[i].fecha,
                    'dd-MM-yyyy HH:mm'
                  ),
                  fechaAlta: this.dateFormatter.transform(
                    data.body[i].fechaAlta,
                    'dd-MM-yyyy HH:mm'
                  ),
                  fechaUltimaMod: data.body[i].fechaUltimaMod,
                  id: data.body[i].id,
                  idAreaComponente: data.body[i].idAreaComponente,
                  idResponsable: data.body[i].idResponsable,
                  idSeveridad: data.body[i].idSeveridad,
                  idTipoAveria: data.body[i].idTipoAveria,
                  idZonaCuadranteDetalle: data.body[i].idZonaCuadranteDetalle,
                  observacion: data.body[i].observacion,
                  proceso: data.body[i].proceso,
                  responsable: data.body[i].responsable,
                  severidad: data.body[i].severidad,
                  tipoAveria: data.body[i].tipoAveria,
                  usuarioAlta: data.body[i].usuarioAlta,
                  usuarioUltimaMod: data.body[i].usuarioUltimaMod,
                  vin: data.body[i].vin.toUpperCase(),
                  zonaCuadranteDetalle: data.body[i].zonaCuadranteDetalle,
                  modelo: data.body[i].modelo,
                  clasificacion: data.body[i].clasificacion,
                  receptor: data.body[i].receptor,
                  cedente: data.body[i].cedente,
                  codificacion: data.body[i].codificacion,
                  tipoResponsable: data.body[i].tipoResponsable,
                  transporte: data.body[i].transporte,
                  transporteReceptor: data.body[i].transporteReceptor,
                  identificador: data.body[i].transporte,
                  //agrego comentarioAveria
                  comentarioAveria: data.body[i].comentarioAveria,
                });
              if ( data.body[i].length > 0) {
                  this.filasExpandidas.add(data.body[i].id);
                }

              }
              this.datasetConsultas = mockDataset;
              this.bloqueoGenerar = false;
              this.cantidadAverias = this.datasetConsultas.length;
              this.deshabilitarExportAverias = false;
            } else {
              this.openSnackBar(
                'No existen registros para la busqueda realizada'
              );
              this.showGrilla = false;
              this.bloqueoSinAverias = false;
              this.botonSinAveriasFlag = true;
            }
          } else if (data['status'] == 403) {
            this.openSnackBar(data['errors'][0].message);
          } else {
            this.openSnackBar('Ocurrio un error al guardar los datos');
          }
        },
        (error) => {
          if (error['status'] == 403) {
            // this.openSnackBar(error.error["errors"][0].message);
            alert(error.error['errors'][0].message);
          } else {
            this.openSnackBar('Ocurrio un error al consultar los datos');
          }
          this.showSpinner = false;
          // this.showGrilla = true;
        }
      );
    } else {
      this.openSnackBar('Seleccione rango de fecha válido');
      this.showSpinner = false;
    }
  }
  buscarAverias() {
    let filtro: consultaAveriasDTO;
    this.showSpinner = true;
    this.showGrilla = false;
    this.bloqueoGenerar = true;
    this.bloqueoSinAverias = true;
    this.deshabilitarExportAverias = true;

    filtro = {
      receptor: [],
      cedente: [],
      fechaDesdeInspeccion:
        this.mostrar.fechas == false
          ? null
          : this.dateFormatter.transform(this.fechaDesdeInspec, 'yyyy-MM-ddT') +
            '00:00:00',
      fechaHastaInspeccion:
        this.mostrar.fechas == false
          ? null
          : this.dateFormatter.transform(this.fechaHastaInspec, 'yyyy-MM-ddT') +
            '23:59:00',
      //cambiamos esta busqueda para que si estas logueado como operador solo puedas ver tus averias
      //y si estas como cliente puedas ver todas.
      responsable:
        this.esCliente == 'true'
          ? this.mostrar.responsable == false
            ? null
            : [Number(this.responsableSelected)]
          : [this.idOperador],
      // responsable: this.mostrar.responsable == false ? null : [Number(this.responsableSelected)],
     // proceso: this.mostrar.proceso == false ? null : this.procesoSelected,
      proceso: this.mostrar.proceso == false ? this.mostrar.procesosvisitas == false ? null : this.procesoSelected  : this.procesoSelected,
      
      vin: this.mostrar.vin == false ? null : this.vinSelected, //quizas tiene que hacer aca el chequeo de que existe el vin para generar el pdf sin averias
      transporte:
        this.mostrar.buque == false
          ? null
          : this.reporteSelected == 2
          ? this.buqueSelected
          : null,
      transporteReceptor:
        this.mostrar.buque == false
          ? null
          : this.reporteSelected == 1
          ? this.buqueSelected
          : null,
      idCliente: this.idCliente,
      idTipoReporte: this.reporteSelected,
     codigoVisitaExterna: this.mostrar.procesosvisitas == false? null : this.visitaSelected.Codigo, 
     idbuque: this.visitaSelected.idbuque
    };

    this.datasetConsultas = [];
    this.bloqueoGenerar = false;
    this.cantidadAverias = this.datasetConsultas.length;
    this.deshabilitarExportAverias = false;

    if (this.fechaDesdeInspec <= this.fechaHastaInspec) {
      this.cantidadAverias = 0;
      this.filtrado = 0;
      this.cantidadInspecciones = 0;
      this.servicioAverias.getAverias(filtro).subscribe(
        (data) => {
          //console.log(data);
          if (data['status'] == 200) {
            this.showSpinner = false;
            this.showGrilla = true;
            if (data.body.length > 0) {
              let mockDataset: any = [];
              for (let i = 0; i < data.body.length; i++) {
                mockDataset.push({
                  areaComponente: data.body[i].areaComponente,
                  // fecha: data.body[i].fecha,
                  fecha: this.dateFormatter.transform(
                    data.body[i].fecha,
                    'dd-MM-yyyy HH:mm'
                  ),
                  fechaAlta: this.dateFormatter.transform(
                    data.body[i].fechaAlta,
                    'dd-MM-yyyy HH:mm'
                  ),
                  fechaUltimaMod: data.body[i].fechaUltimaMod,
                  id: data.body[i].id,
                  idAreaComponente: data.body[i].idAreaComponente,
                  idResponsable: data.body[i].idResponsable,
                  idSeveridad: data.body[i].idSeveridad,
                  idTipoAveria: data.body[i].idTipoAveria,
                  idZonaCuadranteDetalle: data.body[i].idZonaCuadranteDetalle,
                  observacion: data.body[i].observacion,
                  proceso: data.body[i].proceso,
                  responsable: data.body[i].responsable,
                  severidad: data.body[i].severidad,
                  tipoAveria: data.body[i].tipoAveria,
                  usuarioAlta: data.body[i].usuarioAlta,
                  usuarioUltimaMod: data.body[i].usuarioUltimaMod,
                  vin: data.body[i].vin.toUpperCase(),
                  zonaCuadranteDetalle: data.body[i].zonaCuadranteDetalle,
                  modelo: data.body[i].modelo,
                  clasificacion: data.body[i].clasificacion,
                  receptor: data.body[i].receptor,
                  cedente: data.body[i].cedente,
                  codificacion: data.body[i].codificacion,
                  tipoResponsable: data.body[i].tipoResponsable,
                  transporte: data.body[i].transporte,
                  transporteReceptor: data.body[i].transporteReceptor,
                  identificador: data.body[i].transporte,
                  //agrego comentarioAveria
                  comentarioAveria: data.body[i].comentarioAveria,
                });

                // 🔹 Si tiene detalle, marcarlo como expandido
                if ( data.body[i].length > 0) {
                  this.filasExpandidas.add(data.body[i].id);
                }

              }
              this.datasetConsultas = mockDataset;
              this.bloqueoGenerar = false;
              this.cantidadAverias = this.datasetConsultas.length;
              this.deshabilitarExportAverias = false;
            } else {
              this.openSnackBar(
                'No existen registros para la busqueda realizada'
              );
              this.showGrilla = false;
              this.bloqueoSinAverias = false;
              this.botonSinAveriasFlag = true;
            }
          } else if (data['status'] == 403) {
            this.openSnackBar(data['errors'][0].message);
          } else {
            this.openSnackBar('Ocurrio un error al guardar los datos');
          }
        },
        (error) => {
          if (error['status'] == 403) {
            // this.openSnackBar(error.error["errors"][0].message);
            if(this.reporteSelected == 19)
              this.bloqueoGenerar = true;

            alert(error.error['errors'][0].message);
            
          } else {
            this.openSnackBar('Ocurrio un error al consultar los datos');
          }
          this.showSpinner = false;
          // this.showGrilla = true;
        }
      );
    } else {
      this.openSnackBar('Seleccione rango de fecha válido');
      this.showSpinner = false;
    }
  }
  buscarInspeccionAveria() {
    let filtro: consultaAveriasDTO;
    this.showSpinner = true;
    this.showGrilla = false;
    this.bloqueoGenerar = true;
    this.deshabilitarExportAverias = true;

    filtro = {
      receptor: [this.pasarReceptor == 0 ? null : this.pasarReceptor],
      cedente: [this.pasarCedente == 0 ? null : this.pasarCedente],
      fechaDesdeInspeccion:
        this.mostrar.fechas == false
          ? null
          : this.dateFormatter.transform(this.fechaDesdeInspec, 'yyyy-MM-ddT') +
            '00:00:00',
      fechaHastaInspeccion:
        this.mostrar.fechas == false
          ? null
          : this.dateFormatter.transform(this.fechaHastaInspec, 'yyyy-MM-ddT') +
            '23:59:00',
      //cambiamos esta busqueda para que si estas logueado como operador solo puedas ver tus averias
      //y si estas como cliente puedas ver todas.
      responsable: this.reporteSelected == 14 ? [this.idOperador] : [0],
      proceso: this.mostrar.proceso == false ? null : this.procesoSelected,
      vin: '',
      transporte: '',
      transporteReceptor: '',
      idCliente: this.idCliente,
      idTipoReporte: this.reporteSelected,
      codigoVisitaExterna: null,
      idbuque: null
    };
    if (this.fechaDesdeInspec <= this.fechaHastaInspec) {
      this.cantidadAverias = 0;
      this.filtrado = 0;
      this.cantidadInspecciones = 0;
      this.servicioAverias.getListaAverias(filtro).subscribe(
        (data) => {
          //console.log(data);
          if (data['status'] == 200) {
            this.showSpinner = false;
            this.showGrilla = true;
            if (data.body.length > 0) {
              let mockDataset: any = [];
              for (let i = 0; i < data.body.length; i++) {
                mockDataset.push({
                  areaComponente: data.body[i].areaComponente,
                  fecha: this.dateFormatter.transform(
                    data.body[i].fecha,
                    'dd-MM-yyyy HH:mm'
                  ),
                  fechaAlta: this.dateFormatter.transform(
                    data.body[i].fechaAlta,
                    'dd-MM-yyyy HH:mm'
                  ),
                  fechaUltimaMod: data.body[i].fechaUltimaMod,
                  id: data.body[i].id,
                  idAreaComponente: data.body[i].idAreaComponente,
                  idResponsable: data.body[i].idResponsable,
                  idSeveridad: data.body[i].idSeveridad,
                  idTipoAveria: data.body[i].idTipoAveria,
                  idZonaCuadranteDetalle: data.body[i].idZonaCuadranteDetalle,
                  observacion: data.body[i].observacion,
                  proceso: data.body[i].proceso,
                  responsable: data.body[i].responsable,
                  tipoResponsable: data.body[i].tipoResponsable,
                  severidad: data.body[i].severidad,
                  tipoAveria: data.body[i].tipoAveria,
                  usuarioAlta: data.body[i].usuarioAlta,
                  usuarioUltimaMod: data.body[i].usuarioUltimaMod,
                  vin: data.body[i].vin.toUpperCase(),
                  zonaCuadranteDetalle: data.body[i].zonaCuadranteDetalle,
                  modelo: data.body[i].modelo,
                  clasificacion: data.body[i].clasificacion,
                  receptor: data.body[i].receptor,
                  cedente: data.body[i].cedente,
                  idVinAveria: data.body[i].idVinAveria,
                  codificacion: data.body[i].codificacion,
                  comentarioDiscrepancia: data.body[i].comentarioDiscrepancia,
                  usuarioDiscrepancia: data.body[i].usuarioDiscrepancia,
                  identificador: data.body[i].identificador,
                  // agrego comentarioAveria para daños por recepcion reporte 11
                  // cambiar este comentario para que llegue el correcto
                  comentarioAveria: data.body[i].comentarioDiscrepancia
                    ? data.body[i].comentarioDiscrepancia
                    : 'No',
                  // estado de la discrepancia para daños por recepcion reporte 11
                  estadoAveria: data.body[i].estadoAveria,
                });

                if ( data.body[i].length > 0) {
                  this.filasExpandidas.add(data.body[i].id);
                }

              }
              this.datasetConsultas = mockDataset;
              this.bloqueoGenerar = false;
              this.cantidadAverias = this.datasetConsultas.length;
              this.deshabilitarExportAverias = false;
            } else {
              this.openSnackBar(
                'No existen registros para la busqueda realizada'
              );
              this.showGrilla = false;
            }
          } else if (data['status'] == 403) {
            this.openSnackBar(data['errors'][0].message);
          } else {
            this.openSnackBar('Ocurrio un error al guardar los datos');
          }
        },
        (erros) => {
          this.showSpinner = false;
          this.showGrilla = true;
        }
      );
    } else {
      this.openSnackBar('Seleccione rango de fecha válido');
      this.showSpinner = false;
    }
  }
  buscarInspeccionAveriaOperador() {
    let filtro: consultaAveriasDTO;
    this.showSpinner = true;
    this.showGrilla = false;
    this.bloqueoGenerar = true;
    this.deshabilitarExportAverias = true;
    var cantAveria = 0;
    filtro = {
      receptor: [this.pasarReceptor == 0 ? null : this.pasarReceptor],
      cedente: [this.pasarCedente == 0 ? null : this.pasarCedente],
      fechaDesdeInspeccion:
        this.mostrar.fechas == false
          ? null
          : this.dateFormatter.transform(this.fechaDesdeInspec, 'yyyy-MM-ddT') +
            '00:00:00',
      fechaHastaInspeccion:
        this.mostrar.fechas == false
          ? null
          : this.dateFormatter.transform(this.fechaHastaInspec, 'yyyy-MM-ddT') +
            '23:59:00',
      //cambiamos esta busqueda para que si estas logueado como operador solo puedas ver tus averias
      //y si estas como cliente puedas ver todas.
      responsable:
        this.esCliente == 'true'
          ? this.mostrar.responsable == false
            ? null
            : [Number(this.responsableSelected)]
          : [this.idOperador],
      // responsable: this.mostrar.responsable == false ? null : [Number(this.responsableSelected)],
      proceso: this.mostrar.proceso == false ? null : this.procesoSelected,
      vin: this.mostrar.vin == false ? null : this.vinSelected,
      transporte: this.mostrar.buque == false ? null : this.buqueSelected,
      transporteReceptor:
        this.mostrar.buque == false ? null : this.buqueSelected,
      idCliente: this.idCliente,
      idTipoReporte: this.reporteSelected,
      codigoVisitaExterna: null,
      idbuque: null
    };
    if (this.fechaDesdeInspec <= this.fechaHastaInspec) {
      this.cantidadAverias = 0;
      this.filtrado = 0;
      this.cantidadInspecciones = 0;
      this.servicioAverias
        .getListaInspeccionAveriasPorOperador(filtro)
        .subscribe(
          (data) => {
            if (data['status'] == 200) {
              this.showSpinner = false;
              this.showGrilla = true;
              if (data.body.length > 0) {
                let mockDataset: any = [];
                for (let i = 0; i < data.body.length; i++) {
                  mockDataset.push({
                    id: i,
                    receptor: data.body[i].receptor,
                    cedente: data.body[i].cedente,
                    fechaInspeccion: this.dateFormatter.transform(
                      data.body[i].fechaInspeccion,
                      'dd-MM-yyyy HH:mm'
                    ),
                    vin: data.body[i].vin.toUpperCase(),
                    datosAverias: data.body[i].datosAverias,
                    // averia: data.body[i].datosAverias.length,
                    averia:
                      data.body[i].datosAverias.length > 0
                        ? data.body[i].datosAverias[0].idInspeccion == 0
                          ? 0
                          : data.body[i].datosAverias.length
                        : 0,

                    modelo: data.body[i].modelo,
                    proceso: data.body[i].proceso,
                    identificador: data.body[i].identificador,
                  });

                
                  this.filasExpandidas.add(i);
                

                  cantAveria =
                    cantAveria +
                    (data.body[i].datosAverias.length > 0
                      ? data.body[i].datosAverias[0].idInspeccion == 0
                        ? 0
                        : data.body[i].datosAverias.length
                      : 0);
                }
                this.datasetConsultas = mockDataset;
                this.bloqueoGenerar = false;
                this.cantidadAverias = cantAveria;
                this.cantidadInspecciones = this.datasetConsultas.length;
                this.deshabilitarExportAverias = false;
              } else {
                this.openSnackBar(
                  'No existen registros para la busqueda realizada'
                );
                this.showGrilla = false;
              }
            } else if (data['status'] == 403) {
              this.openSnackBar(data['errors'][0].message);
            } else {
              this.openSnackBar('Ocurrio un error al guardar los datos');
            }
          },
          (erros) => {
            this.showSpinner = false;
            this.showGrilla = true;
          }
        );
    } else {
      this.openSnackBar('Seleccione rango de fecha válido');
      this.showSpinner = false;
    }
  }
  buscarInspeccionesAveriaOperador(item) {
    return new Promise((resolve) => {
      resolve(item);
    });
  }
  fillGrilla() {
    this.gridOptionsConsultas = {
      enableAutoResize: true,
      enableGridMenu: false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: true,
      enableRowSelection: true,
      enableExcelExport: true,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: { selectActiveRow: false },
    };
  }
  obtenerDetalleDiscrepancia(idDiscrepancia: number, solucionada: boolean) {
    var element;
    element = this.discrepancias.find((n) => n.id == idDiscrepancia);
    if (solucionada == false) {
      this.detallesActivas = {
        idDiscrepancia: element.id,
        idVinAveria: element.vinAveria['id'],
        vin: element.vinAveria['vin'],
        receptor: element['receptor'],
        idZonaCuadranteDetalle: element.vinAveria['idZonaCuadranteDetalle'],
        zonaCuadranteDetalle: element.vinAveria['zonaCuadranteDetalle'],
        idAreaComponente: element.vinAveria['idAreaComponente'],
        areaComponente: element.vinAveria['areaComponente'],
        idTipoAveria: element.vinAveria['idTipoAveria'],
        tipoAveria: element.vinAveria['tipoAveria'],
        idSeveridad: element.vinAveria['idSeveridad'],
        severidad: element.vinAveria['severidad'],
        condicionInspeccion: element.vinAveria['condicionInspeccion'],
        condicionUnidad: element.vinAveria['condicionUnidad'],
        modelo:
          element.vinAveria['modelo'] == null
            ? 'S/N'
            : element.vinAveria['modelo'],
        cedente: element['cedente'],
        idResponsable: element.vinAveria['idResponsable'],
        responsable: element.vinAveria['responsable'],
        clasificacion: element.vinAveria['clasificacion'],
        idClasificacion: element.vinAveria['idClasificacion'],
        comentarioDiscrepancia:
          element['comentario'] == null
            ? 'Sin comentario'
            : element['comentario'],
        listaFotosAverias: element.vinAveria.fotosAveria,
        solucionada: element.activo,
        //agrego comentarioAveria
        comentarioModificacion: element.vinAveria.comentarioModificacion,
      };
    } else {
      this.detallesSolucionadas = {
        vin: element.inspeccionVinAveria['vin'],
        receptor: element['receptor'],
        areaReceptor: element.inspeccionVinAveria['areaComponente'],
        averiaReceptor: element.inspeccionVinAveria['tipoAveria'],
        severidadReceptor: element.inspeccionVinAveria['severidad'],
        cedente: element['cedente'],
        areaCedente: element.vinAveria['areaComponente'],
        averiaCedente: element.vinAveria['tipoAveria'],
        severidadCedente: element.vinAveria['severidad'],
        correctaReceptor: false,
        correctaCedente: true,
        listaFotosAverias: element.vinAveria.fotosAveria,
        listaFotosInspecciones: element.inspeccionVinAveria.listaFotosAveria,
        //agrego comentarioAveria
        comentarioModificacion: element.vinAveria.comentarioModificacion,
        // comentarioAveria: element.inspeccionVinAveria.comentarioModificacion CUAL DE LOS DOS??
      };
    }
  }
  //DETALLE DE DISCREPANCIA
  open(solucionada: boolean, idDiscrepancia: number) {
    this.obtenerDetalleDiscrepancia(idDiscrepancia, solucionada);
    if (solucionada == false) {
      this.dialogService
        .open(DiscrepanciasActivasComponent, {
          context: {
            data: this.detallesActivas,
          },
        })
        .onClose.subscribe((solucionada) => {
          if (solucionada) {
            this.buscarDiscrepancias();
          }
        });
    } else {
      this.dialogService.open(DiscrepanciasSolucionadasComponent, {
        context: {
          data: this.detallesSolucionadas,
        },
      });
    }
  }
  cambioReporte(ev) {
    this.datasetConsultas = [];
    this.resetFiltros();
    this.habilitarBotonBuscarConsultas();
    this.habilitarBotonSinAverias();
    this.cantidadAverias = 0;
    this.filtrado = 0;
    this.cantidadInspecciones = 0;
    this.deshabilitarExportAverias = true;
    this.bloqueoGenerar = true;
    this.mostrar.procesosvisitas = false;
    this.usarCheckbox = false;

    switch (Number(ev)) {
      case 1: {
        //PRE-LOAD (exp)
        this.mostrar.buque = true;
        this.mostrar.fechas = true;
        this.mostrar.proceso = false;
        this.mostrar.responsable = false;
        this.mostrar.vin = false;
        this.cambiarGridOptions = false;
        this.showContInsp = false;
        this.showExpo = true;
        this.showRepo = true;
        break;
      }
      case 2: {
        //DESCARGA (imp)
        this.mostrar.buque = true;
        this.mostrar.fechas = true;
        this.mostrar.proceso = false;
        this.mostrar.responsable = false;
        this.mostrar.vin = false;
        this.cambiarGridOptions = false;
        this.showContInsp = false;
        this.showExpo = true;
        this.showRepo = true;
        break;
      }
      case 3: {
        //Averias por fecha, proceso y responsable
        this.mostrar.buque = false;
        this.mostrar.fechas = true;
        this.mostrar.proceso = true;
        this.mostrar.responsable = true;
        this.mostrar.vin = false;
        this.cambiarGridOptions = false;
        this.showContInsp = false;
        this.showExpo = true;
        this.showRepo = true;
        break;
      }
      case 4: {
        //Averias por fecha y proceso integral
        this.mostrar.buque = false;
        this.mostrar.fechas = true;
        this.mostrar.proceso = true;
        this.mostrar.responsable = false;
        this.mostrar.vin = false;
        this.cambiarGridOptions = false;
        this.showContInsp = false;
        this.showExpo = true;
        this.showRepo = true;
        break;
      }
      case 5: {
        //Proforma
        this.mostrar.buque = false;
        this.mostrar.fechas = true;
        this.mostrar.proceso = false;
        this.mostrar.responsable = true;
        this.mostrar.vin = false;
        this.cambiarGridOptions = false;
        this.showContInsp = false;
        this.showExpo = true;
        this.showRepo = true;
        break;
      }
      case 6: {
        //Trazabilidad por vin
        this.mostrar.buque = false;
        this.mostrar.fechas = false;
        this.mostrar.proceso = false;
        this.mostrar.responsable = false;
        this.mostrar.vin = true;
        this.cambiarGridOptions = false;
        this.showExpo = true;
        this.showContInsp = false;
        this.showRepo = true;
        break;
      }
      case 7: {
        //Recepción por fecha y proceso
        this.mostrar.buque = false;
        this.mostrar.fechas = true;
        this.mostrar.proceso = true;
        this.mostrar.responsable = false;
        this.mostrar.vin = false;
        this.cambiarGridOptions = false;
        this.showContInsp = false;
        this.showExpo = true;
        this.showRepo = true;
        break;
      }
      case 8: {
        //Entrega por fecha y proceso
        this.mostrar.buque = false;
        this.mostrar.fechas = true;
        this.mostrar.proceso = true;
        this.mostrar.responsable = false;
        this.mostrar.vin = false;
        this.cambiarGridOptions = false;
        this.showContInsp = false;
        this.showExpo = true;
        this.showRepo = true;
        break;
      }
      case 9: {
        //Inspecciones y averias recepcion por fecha, proceso
        this.mostrar.buque = false;
        this.mostrar.fechas = true;
        this.mostrar.proceso = true;
        this.mostrar.responsable = false;
        this.mostrar.vin = false;
        this.cambiarGridOptions = true;
        this.showContInsp = true;
        this.showExpo = true;
        this.showRepo = false;
        break;
      }
      case 10: {
        //Inspecciones y averias entrega por fecha, proceso
        this.mostrar.buque = false;
        this.mostrar.fechas = true;
        this.mostrar.proceso = true;
        this.mostrar.responsable = false;
        this.mostrar.vin = false;
        this.cambiarGridOptions = true;
        this.showContInsp = true;
        this.showExpo = true;
        this.showRepo = false;
        break;
      }
      case 11: {
        //Recepción por fecha
        this.mostrar.buque = false;
        this.mostrar.fechas = true;
        this.mostrar.proceso = false;
        this.mostrar.responsable = false;
        this.mostrar.vin = false;
        this.cambiarGridOptions = false;
        this.showContInsp = false;
        this.showExpo = true;
        this.showRepo = true;
        break;
      }
      case 12: {
        //Entrega por fecha
        this.mostrar.buque = false;
        this.mostrar.fechas = true;
        this.mostrar.proceso = false;
        this.mostrar.responsable = false;
        this.mostrar.vin = false;
        this.cambiarGridOptions = false;
        this.showContInsp = false;
        this.showExpo = true;
        this.showRepo = true;
        break;
      }
      case 14: {
        //Daños Asignados
        this.mostrar.buque = false;
        this.mostrar.fechas = true;
        this.mostrar.proceso = false;
        this.mostrar.responsable = false;
        this.mostrar.vin = false;
        this.cambiarGridOptions = false;
        this.showContInsp = false;
        this.showExpo = true;
        this.showRepo = false;
        break;
      }
      case 15: {
        //Daños rechazados
        this.mostrar.buque = false;
        this.mostrar.fechas = true;
        this.mostrar.proceso = false;
        this.mostrar.responsable = false;
        this.mostrar.vin = false;
        this.cambiarGridOptions = false;
        this.showContInsp = false;
        this.showExpo = true;
        this.showRepo = false;
        break;
      }
      case 17: {
        //Trazabilidad Recepcion
        this.mostrar.buque = false;
        this.mostrar.fechas = true;
        this.mostrar.proceso = false;
        this.mostrar.responsable = false;
        this.mostrar.vin = false;
        this.cambiarGridOptions = true;
        this.showContInsp = true;
        this.showExpo = true;
        this.showRepo = false;
        break;
      }
      case 18: {
        //Trazabilidad Entrega
        this.mostrar.buque = false;
        this.mostrar.fechas = true;
        this.mostrar.proceso = false;
        this.mostrar.responsable = false;
        this.mostrar.vin = false;
        this.cambiarGridOptions = true;
        this.showContInsp = true;
        this.showExpo = true;
        this.showRepo = false;
        break;
      }
      case 16: {
        //Trazabilidad por Proceso
        this.mostrar.buque = false;
        this.mostrar.fechas = true;
        this.mostrar.proceso = true;
        this.mostrar.responsable = false;
        this.mostrar.vin = false;
        this.cambiarGridOptions = true;
        this.showContInsp = true;
        this.showExpo = true;
        this.showRepo = false;
        break;
      }
      case 13: {
        //Daños sin confirmar
        this.mostrar.buque = false;
        this.mostrar.fechas = false;
        this.mostrar.proceso = false;
        this.mostrar.responsable = false;
        this.mostrar.vin = false;
        this.cambiarGridOptions = false;
        this.showContInsp = false;
        this.showExpo = true;
        this.showRepo = false;
        break;
      }

      case 19: {
        //Daños sin confirmar
        this.mostrar.buque = false;
        this.mostrar.fechas = false;
        this.mostrar.procesosvisitas = true;
        this.mostrar.responsable = false;
        this.mostrar.vin = false;
        this.cambiarGridOptions = false;
        this.showContInsp = false;
        this.showExpo = true;
        this.showRepo = true;
        this.usarCheckbox = true;
        this.showtitle = true
        break;
      }
      default: {
        //statements;
        break;
      }
    }
  }
  resetFiltros() {
    this.buqueSelected = '';
    this.procesoSelected = '';
    this.responsableSelected = '';
    this.vinSelected = '';
    // this.fechaDesdeInspec = new Date();
    // this.fechaHastaInspec = new Date();
    this.showGrilla = false;
    this.visitaSelected = '';
  }
  //GENERAR REPORTE
  openPopUp(tmpl: TemplateRef<any>) {

    //obtengo los filtros aplicados en la grilla
    const filtrosaGrid = this.grilla1.api.getFilterModel();

    if (this.cambiarGridOptions == true) {
      if (this.angularGrid && this.angularGrid.extensionService) {
        this.rowDetailInstance.collapseAll();
      }
    }

    var vinAverias: number[] = [];

    if (
      this.reporteSelected == 7 ||
      this.reporteSelected == 8 ||
      this.reporteSelected == 11 ||
      this.reporteSelected == 12
    ) {

      this.dataFiltered.forEach((element) => {
        vinAverias.push(element.idVinAveria);
      });
    } else {

      // if ( filtrosaGrid.identificador &&
      // filtrosaGrid.identificador.filter &&
      // filtrosaGrid.identificador.filter.trim() !== '') 
      
      if (Object.values(filtrosaGrid).some(f => 
      f &&
      f.filter &&
      f.filter.toString().trim() !== ''
       )){
        //console.log('Existe filtro para el campo identificador');

          this.grilla1.api.forEachNodeAfterFilter((node) => {
          //this.filteredData.push(node.data.id);
           vinAverias.push(node.data.id);
        });

      }
      else
      {
        this.datasetConsultas.forEach((element) => {
        
          if (this.reporteSelected == 9 || this.reporteSelected == 10) {
            if (element.datosAverias.length > 0) {
              element.datosAverias.forEach((averia) => {
                vinAverias.push(averia.idVinAveria);
              });
            }
          } 
          else 
          {
              vinAverias.push(element.id);
          }
        });
      }

    }



    //COMENTADO 11_08
    // this.datasetConsultas.forEach(element => {
    //   if (this.reporteSelected == 7 || this.reporteSelected == 8
    //     || this.reporteSelected == 11 || this.reporteSelected == 12)
    //     vinAverias.push(element.idVinAveria);
    //   else if (this.reporteSelected == 9 || this.reporteSelected == 10) {
    //     if (element.datosAverias.length > 0) {
    //       element.datosAverias.forEach(averia => {
    //         vinAverias.push(averia.idVinAveria);
    //       });
    //     }
    //   }
    //   else
    //     vinAverias.push(element.id);
    // });

    this.filtrosReportes = {
      idVinAverias: vinAverias,
      idTipoReporte: this.reporteSelected,
      transporte: this.buqueSelected,
      fechaDesde: this.fechaDesdeInspec,
      fechaHasta: this.fechaHastaInspec,
      responsable: this.responsableSelected,
      procesos: this.procesoSelected,
      vin: this.vinSelected,
      grilla: false,
      porModelo: false,
      porClasif: false,
      indicadores: false,
      detalles: false,
      fotos: false,
      cantInsp: this.cantidadInspecciones,
      cantAverias: this.cantidadAverias,
      idReceptor: this.idOperador,
      codigoVisitaExterna: this.visitaSelected.Codigo,
      idCliente: this.idCliente,
      idbuque: this.visitaSelected.idbuque,
      filtrogrid: filtrosaGrid
    };
    this.modalRef = this.modalService.show(tmpl, { class: 'modal-lg' });
  }
  hideReport(ev) {
    this.modalRef.hide();
  }
  //REPORTE SIN AVERIAS
  generarReporteSinAverias() {
    const doc = new jsPDF();
    // this.modalRef = this.modalService.show(tmpl, { class: 'modal-lg' });
    var today = new Date();
    var curr_date = today.getDate();
    var curr_month = today.getMonth();
    var curr_year = today.getFullYear();
    var curr_time = today.getHours() + ':' + today.getMinutes();
    var img = new Image();
    img.src = 'assets/img/login/VCA-Login.png';
    doc.addImage(img, 'png', 10, 10, 40, 15);
    // esta fecha queda arriba a la derecha. Marca una distancia de 175 en el eje x y 15 en el eje y, yendo hacia la derecha y hacia abajo.
    // doc.text(`${curr_date}/${curr_month}/${curr_year}`, 175, 15);
    // "La unidad con VIN xxxxxxxxxxxx no presenta averías registradas en VCA al dd/mm/yyyy hh:mm"
    doc.text(
      `La unidad con VIN ${this.vinSelected} no presenta averías`,
      20,
      40
    );
    doc.text(
      `registradas en VCA al ${curr_date}/${curr_month}/${curr_year} ${curr_time}.`,
      20,
      50
    );
    doc.save(`Sin Averias VIN_${this.vinSelected}.pdf`);
  }
  //DETALLE DE AVERIA
  openPopUpEdit(data) {
    let reporte = this.reporteSelected;
    if (
      reporte == 7 ||
      reporte == 8 ||
      reporte == 11 ||
      reporte == 12 ||
      reporte == 13 ||
      reporte == 14 ||
      reporte == 15
    ) {
      this.detalleAveria = data.id;
      const dialog = this.dialogService.open(EditInspeccionAveriaComponent, {
        // closeOnBackdropClick: false,
        // closeOnEsc: false,
        context: {
          detalle: this.detalleAveria,
          tipoReporte: reporte,
        },
      });
    } else {
      this.detalleAveria = data.id;
      const dialog = this.dialogService
        .open(EditAveriaComponent, {
          // closeOnBackdropClick: false,
          // closeOnEsc: false,
          context: {
            detalle: this.detalleAveria,
            tipoReporte: reporte,
          },
        })
        .onClose.subscribe((actualizar) => {
          if (actualizar) {
            this.buscarAverias();
          }
        });
    }
  }
  habilitarBotonBuscar() {
    if (
      this.DesdeDiscrepancia != undefined &&
      this.HastaDiscrepancia != undefined &&
      this.DesdeDiscrepancia != null &&
      this.HastaDiscrepancia != null &&
      this.procesoSelected != ''
    ) {
      if (this.checkSolucionado != false || this.checkActiva != false) {
        this.deshabilitarBuscar = false;
      } else {
        this.deshabilitarBuscar = true;
      }
    } else {
      this.deshabilitarBuscar = true;
    }
  }
  habilitarBotonBuscarConsultas() {
    switch (Number(this.reporteSelected)) {
      case 1: {
        //PRE-LOAD (exp)
        this.mostrar.buque = true;
        this.mostrar.fechas = true;

        if (this.buqueSelected != '' && this.buqueSelected != undefined)
          this.deshabilitarBuscarConsulta = false;
        else this.deshabilitarBuscarConsulta = true;

        break;
      }
      case 2: {
        //DESCARGA (imp)
        this.mostrar.buque = true;
        this.mostrar.fechas = true;
        if (this.buqueSelected != '' && this.buqueSelected != undefined)
          this.deshabilitarBuscarConsulta = false;
        else this.deshabilitarBuscarConsulta = true;

        break;
      }
      case 3: {
        //Averias por fecha, proceso y responsable
        this.mostrar.fechas = true;
        this.mostrar.proceso = true;
        this.mostrar.responsable = true;
        if (
          this.procesoSelected != '' &&
          this.procesoSelected != undefined &&
          this.responsableSelected != '' &&
          this.responsableSelected != undefined
        )
          this.deshabilitarBuscarConsulta = false;
        else this.deshabilitarBuscarConsulta = true;

        break;
      }
      case 4: {
        //Averias por fecha y proceso integral
        this.mostrar.fechas = true;
        this.mostrar.proceso = true;
        if (this.procesoSelected != '' && this.procesoSelected != undefined)
          this.deshabilitarBuscarConsulta = false;
        else this.deshabilitarBuscarConsulta = true;

        break;
      }
      case 5: {
        //Proforma
        this.mostrar.fechas = true;
        this.mostrar.responsable = true;
        if (
          this.responsableSelected != '' &&
          this.responsableSelected != undefined
        )
          this.deshabilitarBuscarConsulta = false;
        else this.deshabilitarBuscarConsulta = true;

        break;
      }
      case 6: {
        //Proforma
        this.mostrar.vin = true;
        if (this.vinSelected != undefined) {
          if (this.vinSelected.length == 17) {
            this.deshabilitarBuscarConsulta = false;
          } else {
            this.deshabilitarBuscarConsulta = true;
            this.botonSinAveriasFlag = false;
          }
        } else {
          this.deshabilitarBuscarConsulta = true;
          this.botonSinAveriasFlag = false;
        }

        break;
      }
      case 7: {
        //Recepcion por Fecha y Proceso
        this.mostrar.fechas = true;
        this.mostrar.proceso = true;
        this.pasarReceptor = this.idOperador;
        this.pasarCedente = 0;
        if (this.procesoSelected != '' && this.procesoSelected != undefined)
          this.deshabilitarBuscarConsulta = false;
        else this.deshabilitarBuscarConsulta = true;

        break;
      }
      case 8: {
        //Entrega por Fecha y Proceso
        this.mostrar.fechas = true;
        this.mostrar.proceso = true;
        this.pasarReceptor = 0;
        this.pasarCedente = this.idOperador;
        if (this.procesoSelected != '' && this.procesoSelected != undefined)
          this.deshabilitarBuscarConsulta = false;
        else this.deshabilitarBuscarConsulta = true;

        break;
      }
      case 9: {
        //Inspecciones por fecha, proceso y responsable
        this.mostrar.fechas = true;
        this.mostrar.proceso = true;
        this.pasarReceptor = this.idOperador;
        this.pasarCedente = 0;
        if (this.procesoSelected != '' && this.procesoSelected != undefined)
          this.deshabilitarBuscarConsulta = false;
        else this.deshabilitarBuscarConsulta = true;

        break;
      }
      case 10: {
        //Inspecciones por fecha y proceso
        this.mostrar.fechas = true;
        this.mostrar.proceso = true;
        this.pasarReceptor = 0;
        this.pasarCedente = this.idOperador;
        if (this.procesoSelected != '' && this.procesoSelected != undefined)
          this.deshabilitarBuscarConsulta = false;
        else this.deshabilitarBuscarConsulta = true;

        break;
      }
      case 11: {
        //Recepcion por Fecha
        this.mostrar.fechas = true;
        this.mostrar.proceso = false;
        this.pasarReceptor = this.idOperador;
        this.pasarCedente = 0;
        this.deshabilitarBuscarConsulta = false;
        // this.deshabilitarBuscarConsulta = true;
        break;
      }
      case 12: {
        //Entrega por Fecha
        this.mostrar.fechas = true;
        this.mostrar.proceso = true;
        this.pasarReceptor = 0;
        this.pasarCedente = this.idOperador;
        this.deshabilitarBuscarConsulta = false;
        // this.deshabilitarBuscarConsulta = true;

        break;
      }
      case 14: {
        //Daños Asignados
        this.mostrar.fechas = true;
        this.mostrar.proceso = false;
        this.pasarReceptor = 0;
        this.pasarCedente = 0;
        this.deshabilitarBuscarConsulta = false;
        // this.deshabilitarBuscarConsulta = true;
        break;
      }
      case 15: {
        //Daños Rechazados
        this.mostrar.fechas = true;
        this.mostrar.proceso = false;
        this.pasarReceptor = 0;
        this.pasarCedente = this.idOperador;
        this.deshabilitarBuscarConsulta = false;
        // this.deshabilitarBuscarConsulta = true;

        break;
      }
      case 17: {
        //Trazabilidad recepcion
        this.mostrar.fechas = true;
        this.mostrar.proceso = false;
        this.pasarReceptor = this.idOperador;
        this.pasarCedente = 0;
        this.deshabilitarBuscarConsulta = false;
        //  this.deshabilitarBuscarConsulta = true;
        break;
      }
      case 18: {
        //Trazabilidad entrega
        this.mostrar.fechas = true;
        this.mostrar.proceso = false;
        this.pasarReceptor = 0;
        this.pasarCedente = this.idOperador;
        this.deshabilitarBuscarConsulta = false;
        //  this.deshabilitarBuscarConsulta = true;
        break;
      }
      case 16: {
        //Trazabilidad por Proceso
        this.mostrar.fechas = true;
        this.mostrar.proceso = true;
        this.pasarReceptor = 0;
        this.pasarCedente = 0;
        if (this.procesoSelected != '' && this.procesoSelected != undefined)
          this.deshabilitarBuscarConsulta = false;
        else this.deshabilitarBuscarConsulta = true;
        break;
      }
      case 13: {
        //Daños sin confirmar
        this.mostrar.fechas = false;
        this.mostrar.proceso = false;
        this.pasarReceptor = 0;
        this.pasarCedente = this.idOperador;
        this.deshabilitarBuscarConsulta = false;
        // this.deshabilitarBuscarConsulta = true;

        break;
      }
      case 19: {
        //Daños sin confirmar
        this.mostrar.fechas = false;
        this.mostrar.proceso = false;
        this.pasarReceptor = 0;
        this.pasarCedente = this.idOperador;
        this.deshabilitarBuscarConsulta = false;
        // this.deshabilitarBuscarConsulta = true;

        break;
      }
      default: {
        //statements;
        break;
      }
    }
  }
  habilitarBotonSinAverias() {
    this.mostrar.vin = true;
    this.botonSinAveriasFlag == false;
    if (this.vinSelected != undefined) {
      if (this.vinSelected.length == 17 && this.botonSinAveriasFlag == true) {
        this.bloqueoSinAverias = false;
      } else {
        this.bloqueoSinAverias = true;
      }
    } else {
      this.bloqueoSinAverias = true;
    }
    return;
  }
  changeResponsable() {
    this.habilitarBotonBuscarConsultas();
  }
  changeBuque() {
    this.habilitarBotonBuscarConsultas();
  }
  changeVin() {
    this.habilitarBotonBuscarConsultas();
    this.habilitarBotonSinAverias();
  }
  changeProceso() {
    this.habilitarBotonBuscarConsultas();
  }
  changeProcesoDiscrepancia() {
    this.habilitarBotonBuscar();
  }
  openSnackBar(mensaje: string) {
    this._snackBar.openFromComponent(SnackBarComponent, {
      duration: this.durationInSeconds * 1000,
      data: mensaje,
    });
  }


  // Funciones auxiliares para construir columnas
    getBaseActionColumns(): any[] {
      return [
           {
              headerName: '',         // No texto en el encabezado
              field: 'action',
              cellRenderer: params => {
                return `<i class="fa fa-edit" style="font-size: 16px; cursor: pointer;"></i>`; // Puedes personalizar más si lo deseas
              },
              width: 50,
              minWidth: 50,
              maxWidth: 50,
              //suppressExport: true,  // Equivalente a excludeFromExport
              onCellClicked: params => {
                this.openPopUpEdit(params.data);  // Llama a tu método pasando la fila
              }
            },
                        {
              headerName: '',         // No texto en el encabezado
              field: 'action',
              cellRenderer: params => {
                return `<i class="fa fa-trash" style="font-size: 16px; cursor: pointer;"></i>`; // Puedes personalizar más si lo deseas
              },
              width: 50,
              minWidth: 50,
              maxWidth: 50,
              //suppressExport: true,  // Equivalente a excludeFromExport
              onCellClicked: params => {
                this.openPopupEliminarAveria(params.data);  // Llama a tu método pasando la fila
              }
            },
      ];
    }


  columnsDefinitionsSegunTipoUsuario() {
    const myCustomCheckboxFormatter: Formatter = (
      row: number,
      cell: number,
      value: any,
      columnDef: Column,
      dataContext: any,
      grid?: any
    ) => '<i class="fa fa-edit" style="font-size: 16px;"></i>';

    const myCustomCheckboxDeleteFormatter: Formatter = (
      row: number,
      cell: number,
      value: any,
      columnDef: Column,
      dataContext: any,
      grid?: any
    ) => '<i class="fa fa-trash" style="font-size: 16px;"></i>';

    const actions = this.getBaseActionColumns();

    if (this.usersRol.ELIMINAR_AVERIAS == true) {
          switch (Number(this.reporteSelected)) {
        case 1:
          this.columnDefinitionsConsultas = [
			...actions,
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'responsable',
              headerName: 'Responsable',
              field: 'responsable',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
            },
            {
              //id: 'clasificacion',
              headerName: 'Clasificación',
              field: 'clasificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'areaComponente',
              headerName: 'Área',
              field: 'areaComponente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'tipoAveria',
              headerName: 'Tipo Avería',
              field: 'tipoAveria',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 160,
            },
            {
              //id: 'severidad',
              headerName: 'Severidad',
              field: 'severidad',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'codificacion',
              headerName: 'Codificación',
              field: 'codificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'observacion',
              headerName: 'Observaciones',
              field: 'observacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'transporteReceptor',
              headerName: 'Transporte',
              field: 'transporteReceptor',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'fechaAlta',
              headerName: 'Fecha Avería',
              field: 'fechaAlta',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
          ];
          break;
        case 2:
          this.columnDefinitionsConsultas = [
		   ...actions,
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'responsable',
              headerName: 'Responsable',
              field: 'responsable',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
            },
            {
              //id: 'clasificacion',
              headerName: 'Clasificación',
              field: 'clasificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'areaComponente',
              headerName: 'Área',
              field: 'areaComponente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'tipoAveria',
              headerName: 'Tipo Avería',
              field: 'tipoAveria',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'severidad',
              headerName: 'Severidad',
              field: 'severidad',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'observacion',
              headerName: 'Observaciones',
              field: 'observacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'transporte',
              headerName: 'Transporte',
              field: 'transporte',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'fechaAlta',
              headerName: 'Fecha Avería',
              field: 'fechaAlta',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'codificacion',
              headerName: 'Codificación',
              field: 'codificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
          ];
          break;
        case 3:
          this.columnDefinitionsConsultas = [
            ...actions,
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'proceso',
              headerName: 'Proceso',
              field: 'proceso',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
            },
            {
              //id: 'responsable',
              headerName: 'Responsable',
              field: 'responsable',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'identificador',
              headerName: 'Identificador',
              field: 'identificador',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,
              width: 110,
            },
            {
              //id: 'clasificacion',
              headerName: 'Clasificación',
              field: 'clasificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'areaComponente',
              headerName: 'Área',
              field: 'areaComponente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 160,
            },
            {
              //id: 'tipoAveria',
              headerName: 'Tipo Avería',
              field: 'tipoAveria',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'severidad',
              headerName: 'Severidad',
              field: 'severidad',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'observacion',
              headerName: 'Observaciones',
              field: 'observacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'fechaAlta',
              headerName: 'Fecha Avería',
              field: 'fechaAlta',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'codificacion',
              headerName: 'Codificación',
              field: 'codificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
          ];
          break;
        case 4:
          this.columnDefinitionsConsultas = [
			...actions,
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'proceso',
              headerName: 'Proceso',
              field: 'proceso',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
            },
            {
              //id: 'responsable',
              headerName: 'Responsable',
              field: 'responsable',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'identificador',
              headerName: 'Identificador',
              field: 'identificador',
              sortable: true,
              filter: true, floatingFilter: true,
               minWidth: 150,
              width: 110,
            },
            {
              //id: 'clasificacion',
              headerName: 'Clasificación',
              field: 'clasificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'areaComponente',
              headerName: 'Área',
              field: 'areaComponente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'tipoAveria',
              headerName: 'Tipo Avería',
              field: 'tipoAveria',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'severidad',
              headerName: 'Severidad',
              field: 'severidad',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 160,
            },
            {
              //id: 'observacion',
              headerName: 'Observaciones',
              field: 'observacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'codificacion',
              headerName: 'Codificación',
              field: 'codificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'fechaAlta',
              headerName: 'Fecha Avería',
              field: 'fechaAlta',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
          ];
          break;
        case 5:
          this.columnDefinitionsConsultas = [
			...actions,
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'proceso',
              headerName: 'Proceso',
              field: 'proceso',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
            },
            {
              //id: 'responsable',
              headerName: 'Responsable',
              field: 'responsable',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'identificador',
              headerName: 'Identificador',
              field: 'identificador',
              sortable: true,
              filter: true, floatingFilter: true,
               minWidth: 150,
              width: 110,
            },
            {
              //id: 'clasificacion',
              headerName: 'Clasificación',
              field: 'clasificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'areaComponente',
              headerName: 'Área',
              field: 'areaComponente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'tipoAveria',
              headerName: 'Tipo Avería',
              field: 'tipoAveria',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'severidad',
              headerName: 'Severidad',
              field: 'severidad',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'observacion',
              headerName: 'Observaciones',
              field: 'observacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'codificacion',
              headerName: 'Codificación',
              field: 'codificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'fechaAlta',
              headerName: 'Fecha Avería',
              field: 'fechaAlta',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
          ];
          break;
        case 6:
          this.columnDefinitionsConsultas = [
			...actions,
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'proceso',
              headerName: 'Proceso',
              field: 'proceso',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
            },
            {
              //id: 'responsable',
              headerName: 'Responsable',
              field: 'responsable',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'identificador',
              headerName: 'Identificador',
              field: 'identificador',
              sortable: true,
              filter: true, floatingFilter: true,
               minWidth: 150,
              width: 110,
            },
            {
              //id: 'clasificacion',
              headerName: 'Clasificación',
              field: 'clasificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'areaComponente',
              headerName: 'Área',
              field: 'areaComponente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'tipoAveria',
              headerName: 'Tipo Avería',
              field: 'tipoAveria',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'severidad',
              headerName: 'Severidad',
              field: 'severidad',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'observacion',
              headerName: 'Observaciones',
              field: 'observacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'codificacion',
              headerName: 'Codificación',
              field: 'codificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'fechaAlta',
              headerName: 'Fecha Avería',
              field: 'fechaAlta',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
          ];
          break;
        case 7:
          this.columnDefinitionsConsultas = [
			      ...actions,
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'proceso',
              headerName: 'Proceso',
              field: 'proceso',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
            },
            {
              //id: 'responsable',
              headerName: 'Responsable',
              field: 'responsable',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'clasificacion',
              headerName: 'Clasificación',
              field: 'clasificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'areaComponente',
              headerName: 'Área',
              field: 'areaComponente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'tipoAveria',
              headerName: 'Tipo Avería',
              field: 'tipoAveria',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'severidad',
              headerName: 'Severidad',
              field: 'severidad',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'observacion',
              headerName: 'Observaciones',
              field: 'observacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'receptor',
              headerName: 'Receptor',
              field: 'receptor',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'cedente',
              headerName: 'Cedente',
              field: 'cedente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'fechaAlta',
              headerName: 'Fecha Avería',
              field: 'fechaAlta',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'codificacion',
              headerName: 'Codificación',
              field: 'codificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
          ];
          break;
        case 8:
          this.columnDefinitionsConsultas = [
			...actions,
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'proceso',
              headerName: 'Proceso',
              field: 'proceso',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
            },
            {
              //id: 'responsable',
              headerName: 'Responsable',
              field: 'responsable',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'clasificacion',
              headerName: 'Clasificación',
              field: 'clasificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'areaComponente',
              headerName: 'Área',
              field: 'areaComponente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'tipoAveria',
              headerName: 'Tipo Avería',
              field: 'tipoAveria',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'severidad',
              headerName: 'Severidad',
              field: 'severidad',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'observacion',
              headerName: 'Observaciones',
              field: 'observacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'receptor',
              headerName: 'Receptor',
              field: 'receptor',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'cedente',
              headerName: 'Cedente',
              field: 'cedente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'fechaAlta',
              headerName: 'Fecha Avería',
              field: 'fechaAlta',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'codificacion',
              headerName: 'Codificación',
              field: 'codificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
          ];
          break;
        case 9:
          this.columnDefinitionsConsultas = [
              GrillaColumns.getExpandColumn(this.filasExpandidas,this),
              GrillaColumns.getDetalleColumn(),
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'fechaInspeccion',
              headerName: 'Fecha Inspeccion',
              field: 'fechaInspeccion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'proceso',
              headerName: 'Proceso',
              field: 'proceso',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'cedente',
              headerName: 'Cedente',
              field: 'cedente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'receptor',
              headerName: 'Receptor',
              field: 'receptor',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'identificador',
              headerName: 'Identificador',
              field: 'identificador',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,
              width: 110,
            },
            {
              //id: 'averia',
              headerName: 'Averias',
              field: 'averia',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
              width: 90,
            },
          ];
          break;
        case 10:
          this.columnDefinitionsConsultas = [
              GrillaColumns.getExpandColumn(this.filasExpandidas,this),
              GrillaColumns.getDetalleColumn(),
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'fechaInspeccion',
              headerName: 'Fecha Inspeccion',
              field: 'fechaInspeccion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'proceso',
              headerName: 'Proceso',
              field: 'proceso',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'cedente',
              headerName: 'Cedente',
              field: 'cedente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'receptor',
              headerName: 'Receptor',
              field: 'receptor',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'identificador',
              headerName: 'Identificador',
              field: 'identificador',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,
              width: 110,
            },
            {
              //id: 'averia',
              headerName: 'Averias',
              field: 'averia',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
              width: 90,
            },
          ];
          break;
        case 11:
          this.columnDefinitionsConsultas = [
          ...actions,
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'proceso',
              headerName: 'Proceso',
              field: 'proceso',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
            },
            {
              //id: 'tipoResponsable',
              headerName: 'Tipo Responsable',
              field: 'tipoResponsable',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 130,
            },
            {
              //id: 'clasificacion',
              headerName: 'Clasificación',
              field: 'clasificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'areaComponente',
              headerName: 'Área',
              field: 'areaComponente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'tipoAveria',
              headerName: 'Tipo Avería',
              field: 'tipoAveria',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'severidad',
              headerName: 'Severidad',
              field: 'severidad',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'observacion',
              headerName: 'Observaciones',
              field: 'observacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'receptor',
              headerName: 'Receptor',
              field: 'receptor',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'cedente',
              headerName: 'Cedente',
              field: 'cedente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'fecha',
              headerName: 'Fecha',
              field: 'fecha',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'codificacion',
              headerName: 'Codificación',
              field: 'codificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'estadoAveria',
              headerName: 'Estado',
              field: 'estadoAveria',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'comentarioAveria',
              headerName: 'Comentario Discrepancia',
              field: 'comentarioAveria',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
          ];
          break;
        case 12:
          this.columnDefinitionsConsultas = [
          ...actions, 
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'proceso',
              headerName: 'Proceso',
              field: 'proceso',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
            },
            {
              //id: 'tipoResponsable',
              headerName: 'Tipo Responsable',
              field: 'tipoResponsable',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 130,
            },
            {
              //id: 'clasificacion',
              headerName: 'Clasificación',
              field: 'clasificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'areaComponente',
              headerName: 'Área',
              field: 'areaComponente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'tipoAveria',
              headerName: 'Tipo Avería',
              field: 'tipoAveria',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'severidad',
              headerName: 'Severidad',
              field: 'severidad',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'observacion',
              headerName: 'Observaciones',
              field: 'observacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'receptor',
              headerName: 'Receptor',
              field: 'receptor',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'cedente',
              headerName: 'Cedente',
              field: 'cedente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'fecha',
              headerName: 'Fecha',
              field: 'fecha',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'codificacion',
              headerName: 'Codificación',
              field: 'codificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
          ];
          break;
        case 14:
          this.columnDefinitionsConsultas = [
          ...actions, 
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'proceso',
              headerName: 'Proceso',
              field: 'proceso',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
            },
            {
              //id: 'clasificacion',
              headerName: 'Clasificación',
              field: 'clasificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'areaComponente',
              headerName: 'Área',
              field: 'areaComponente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'tipoAveria',
              headerName: 'Tipo Avería',
              field: 'tipoAveria',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'severidad',
              headerName: 'Severidad',
              field: 'severidad',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'observacion',
              headerName: 'Observaciones',
              field: 'observacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            // { //id: 'receptor', headerName: 'Receptor', field: 'receptor', sortable: true, filter: true, floatingFilter: true, minWidth: 100},
            // { //id: 'cedente', headerName: 'Cedente', field: 'cedente', sortable: true, filter: true, floatingFilter: true, minWidth: 100},
            {
              //id: 'fecha',
              headerName: 'Fecha',
              field: 'fecha',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'codificacion',
              headerName: 'Codificación',
              field: 'codificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
          ];
          break;
        case 15:
          this.columnDefinitionsConsultas = [
          ...actions,
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'proceso',
              headerName: 'Proceso',
              field: 'proceso',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
            },
            // { //id: 'tipoResponsable', headerName: 'Tipo Responsable', field: 'tipoResponsable', sortable: true, filter: true, floatingFilter: true, minWidth: 130},
            {
              //id: 'clasificacion',
              headerName: 'Clasificación',
              field: 'clasificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'areaComponente',
              headerName: 'Área',
              field: 'areaComponente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'tipoAveria',
              headerName: 'Tipo Avería',
              field: 'tipoAveria',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'severidad',
              headerName: 'Severidad',
              field: 'severidad',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'observacion',
              headerName: 'Observaciones',
              field: 'observacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'receptor',
              headerName: 'Receptor',
              field: 'receptor',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'cedente',
              headerName: 'Cedente',
              field: 'cedente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'identificador',
              headerName: 'Identificador',
              field: 'identificador',
              sortable: true,
              filter: true, floatingFilter: true,
               minWidth: 150,
              width: 110,
            },
            {
              //id: 'comentarioDiscrepancia',
              headerName: 'Comentario Discrepancia',
              field: 'comentarioDiscrepancia',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 180,
            },
            {
              //id: 'usuarioDiscrepancia',
              headerName: 'Usuario Cedente',
              field: 'usuarioDiscrepancia',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'fecha',
              headerName: 'Fecha',
              field: 'fecha',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'codificacion',
              headerName: 'Codificación',
              field: 'codificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
          ];
          break;
        case 17:
          this.columnDefinitionsConsultas = [
            GrillaColumns.getExpandColumn(this.filasExpandidas,this),
            GrillaColumns.getDetalleColumn(),
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'fechaInspeccion',
              headerName: 'Fecha Inspeccion',
              field: 'fechaInspeccion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'proceso',
              headerName: 'Proceso',
              field: 'proceso',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'cedente',
              headerName: 'Cedente',
              field: 'cedente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'receptor',
              headerName: 'Receptor',
              field: 'receptor',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            // {//id: 'identificador', headerName: 'Identificador', field: 'identificador', sortable: true, filter: true, floatingFilter: true, minWidth: 80},
            {
              //id: 'averia',
              headerName: 'Averias',
              field: 'averia',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
              width: 90,
            },
          ];
          break;
        case 18:
          this.columnDefinitionsConsultas = [
            GrillaColumns.getExpandColumn(this.filasExpandidas,this),
            GrillaColumns.getDetalleColumn(),
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'fechaInspeccion',
              headerName: 'Fecha Inspeccion',
              field: 'fechaInspeccion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'proceso',
              headerName: 'Proceso',
              field: 'proceso',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'cedente',
              headerName: 'Cedente',
              field: 'cedente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'receptor',
              headerName: 'Receptor',
              field: 'receptor',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            // {//id: 'identificador', headerName: 'Identificador', field: 'identificador', sortable: true, filter: true, floatingFilter: true, minWidth: 80},
            {
              //id: 'averia',
              headerName: 'Averias',
              field: 'averia',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
              width: 90,
            },
          ];
          break;
        case 16:
          this.columnDefinitionsConsultas = [
               GrillaColumns.getExpandColumn(this.filasExpandidas,this),
               GrillaColumns.getDetalleColumn(),
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,
              width: 150,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
              width: 190,
            },
            {
              //id: 'fechaInspeccion',
              headerName: 'Fecha Inspeccion',
              field: 'fechaInspeccion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,
              width: 150,
            },
            {
              //id: 'proceso',
              headerName: 'Proceso',
              field: 'proceso',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,
              width: 150,
            },
            {
              //id: 'cedente',
              headerName: 'Cedente',
              field: 'cedente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,
              width: 150,
            },
            {
              //id: 'receptor',
              headerName: 'Receptor',
              field: 'receptor',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,
              width: 150,
            },
            {
              //id: 'identificador',
              headerName: 'Identificador',
              field: 'identificador',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,
              width: 110,
            },
            {
              //id: 'averia',
              headerName: 'Averias',
              field: 'averia',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
              width: 90,
            },
          ];
          break;
        case 13:
          this.columnDefinitionsConsultas = [
			...actions,
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'proceso',
              headerName: 'Proceso',
              field: 'proceso',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
            },
            // { //id: 'tipoResponsable', headerName: 'Tipo Responsable', field: 'tipoResponsable', sortable: true, filter: true, floatingFilter: true, minWidth: 130},

            {
              //id: 'clasificacion',
              headerName: 'Clasificación',
              field: 'clasificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'areaComponente',
              headerName: 'Área',
              field: 'areaComponente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'tipoAveria',
              headerName: 'Tipo Avería',
              field: 'tipoAveria',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'severidad',
              headerName: 'Severidad',
              field: 'severidad',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'observacion',
              headerName: 'Observaciones',
              field: 'observacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'receptor',
              headerName: 'Receptor',
              field: 'receptor',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'cedente',
              headerName: 'Cedente',
              field: 'cedente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'identificador',
              headerName: 'Identificador',
              field: 'identificador',
              sortable: true,
              filter: true, floatingFilter: true,
               minWidth: 150,
              width: 110,
            },
            {
              //id: 'fecha',
              headerName: 'Fecha',
              field: 'fecha',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
              type: FieldType.dateIso,
            },
            {
              //id: 'codificacion',
              headerName: 'Codificación',
              field: 'codificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
          ];
          break;
        case 19:
     
          // Column Definitions: Defines the columns to be displayed.
          this.columnDefinitionsConsultas =  [
             ...actions,

              { field: "modelo", 
                headerName: 'Modelo',
                sortable: true,
                filter: true, 
                floatingFilter: true,
                minWidth: 100,
              },
              { field: "vin", 
                headerName: 'Vin',
                sortable: true,
                filter: true,
                floatingFilter: true,
                minWidth: 190,
              },
              { field: "proceso",
                headerName: 'Proceso',
                sortable: true,
                filter: true,
                floatingFilter: true,
                minWidth: 150,width: 150,
              },
              { field: "responsable",
                headerName: 'Responsable',
                sortable: true,
                filter: true,
                floatingFilter: true,
                minWidth: 150,width: 150,
               },
              { field: "identificador",
                headerName: 'Identificador',
                sortable: true,
                filter: true,
                floatingFilter: true,
                 minWidth: 150,
              width: 110,
               },
              { field: "clasificacion",
                headerName: 'Clasificación',
                sortable: true,
                filter: true,
                floatingFilter: true,
                minWidth: 100, 
              },
              { field: "areaComponente",
                headerName: 'Área',
                sortable: true,
                filter: true,
                floatingFilter: true,
                minWidth: 100, 
              },
              { field: "tipoAveria",
                headerName: 'Tipo Avería',
                sortable: true,
                filter: true,
                floatingFilter: true,
                minWidth: 100,
              },
              { field: "severidad",
                headerName: 'Severidad',
                sortable: true,
                filter: true,
                floatingFilter: true,
                minWidth: 100, 
              },
              { field: "observacion",
                headerName: 'Observaciones',
                sortable: true,
                filter: true,
                floatingFilter: true,
                minWidth: 100, 
              },
              { field: "codificacion",
                headerName: 'Codificación',
                sortable: true,
                filter: true,
                floatingFilter: true,
                minWidth: 100, 
              },
              { field: "fechaAlta",
                headerName: 'Fecha Avería',
                sortable: true,
                filter: true,
                floatingFilter: true,
                minWidth: 100, 
              },
          ];

          break;
        default:
          this.columnDefinitionsConsultas = [
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'responsable',
              headerName: 'Responsable',
              field: 'responsable',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'clasificacion',
              headerName: 'Clasificación',
              field: 'clasificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'areaComponente',
              headerName: 'Área',
              field: 'areaComponente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'tipoAveria',
              headerName: 'Tipo Avería',
              field: 'tipoAveria',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'severidad',
              headerName: 'Severidad',
              field: 'severidad',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'codificacion',
              headerName: 'Codificación',
              field: 'codificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
          ];
          break;
      }
 
    } else {

       switch (Number(this.reporteSelected)) {
        case 1:
          this.columnDefinitionsConsultas = [
			actions[0],
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 60,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'responsable',
              headerName: 'Responsable',
              field: 'responsable',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
            },
            {
              //id: 'clasificacion',
              headerName: 'Clasificación',
              field: 'clasificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'areaComponente',
              headerName: 'Área',
              field: 'areaComponente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'tipoAveria',
              headerName: 'Tipo Avería',
              field: 'tipoAveria',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'severidad',
              headerName: 'Severidad',
              field: 'severidad',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'codificacion',
              headerName: 'Codificación',
              field: 'codificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'observacion',
              headerName: 'Observaciones',
              field: 'observacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'transporteReceptor',
              headerName: 'Transporte',
              field: 'transporteReceptor',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'fechaAlta',
              headerName: 'Fecha Avería',
              field: 'fechaAlta',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
          ];
          break;
        case 2:
          this.columnDefinitionsConsultas = [
            actions[0],
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'responsable',
              headerName: 'Responsable',
              field: 'responsable',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
            },
            {
              //id: 'clasificacion',
              headerName: 'Clasificación',
              field: 'clasificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'areaComponente',
              headerName: 'Área',
              field: 'areaComponente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'tipoAveria',
              headerName: 'Tipo Avería',
              field: 'tipoAveria',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'severidad',
              headerName: 'Severidad',
              field: 'severidad',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'observacion',
              headerName: 'Observaciones',
              field: 'observacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'codificacion',
              headerName: 'Codificación',
              field: 'codificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'transporte',
              headerName: 'Transporte',
              field: 'transporte',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'fechaAlta',
              headerName: 'Fecha Avería',
              field: 'fechaAlta',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
          ];
          break;
        case 3:
          this.columnDefinitionsConsultas = [
			actions[0],
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'proceso',
              headerName: 'Proceso',
              field: 'proceso',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
            },
            {
              //id: 'responsable',
              headerName: 'Responsable',
              field: 'responsable',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'identificador',
              headerName: 'Identificador',
              field: 'identificador',
              sortable: true,
              filter: true, floatingFilter: true,
               minWidth: 150,
              width: 110,
            },
            {
              //id: 'clasificacion',
              headerName: 'Clasificación',
              field: 'clasificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'areaComponente',
              headerName: 'Área',
              field: 'areaComponente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'tipoAveria',
              headerName: 'Tipo Avería',
              field: 'tipoAveria',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'severidad',
              headerName: 'Severidad',
              field: 'severidad',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'observacion',
              headerName: 'Observaciones',
              field: 'observacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'codificacion',
              headerName: 'Codificación',
              field: 'codificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'fechaAlta',
              headerName: 'Fecha Avería',
              field: 'fechaAlta',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
          ];
          break;
        case 4:
          this.columnDefinitionsConsultas = [
			actions[0],
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'proceso',
              headerName: 'Proceso',
              field: 'proceso',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
            },
            {
              //id: 'responsable',
              headerName: 'Responsable',
              field: 'responsable',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'identificador',
              headerName: 'Identificador',
              field: 'identificador',
              sortable: true,
              filter: true, floatingFilter: true,
               minWidth: 150,
              width: 110,
            },
            {
              //id: 'clasificacion',
              headerName: 'Clasificación',
              field: 'clasificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'areaComponente',
              headerName: 'Área',
              field: 'areaComponente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'tipoAveria',
              headerName: 'Tipo Avería',
              field: 'tipoAveria',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'severidad',
              headerName: 'Severidad',
              field: 'severidad',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'observacion',
              headerName: 'Observaciones',
              field: 'observacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'codificacion',
              headerName: 'Codificación',
              field: 'codificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'fechaAlta',
              headerName: 'Fecha Avería',
              field: 'fechaAlta',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
          ];
          break;
        case 5:
          this.columnDefinitionsConsultas = [
			actions[0],
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'proceso',
              headerName: 'Proceso',
              field: 'proceso',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
            },
            {
              //id: 'responsable',
              headerName: 'Responsable',
              field: 'responsable',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'identificador',
              headerName: 'Identificador',
              field: 'identificador',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,
              width: 110,
            },
            {
              //id: 'clasificacion',
              headerName: 'Clasificación',
              field: 'clasificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'areaComponente',
              headerName: 'Área',
              field: 'areaComponente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'tipoAveria',
              headerName: 'Tipo Avería',
              field: 'tipoAveria',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'severidad',
              headerName: 'Severidad',
              field: 'severidad',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'observacion',
              headerName: 'Observaciones',
              field: 'observacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'codificacion',
              headerName: 'Codificación',
              field: 'codificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'fechaAlta',
              headerName: 'Fecha Avería',
              field: 'fechaAlta',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
          ];
          break;
        case 6:
          this.columnDefinitionsConsultas = [
			actions[0],
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'proceso',
              headerName: 'Proceso',
              field: 'proceso',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
            },
            {
              //id: 'responsable',
              headerName: 'Responsable',
              field: 'responsable',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'identificador',
              headerName: 'Identificador',
              field: 'identificador',
              sortable: true,
              filter: true, floatingFilter: true,
               minWidth: 150,
              width: 110,
            },
            {
              //id: 'clasificacion',
              headerName: 'Clasificación',
              field: 'clasificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'areaComponente',
              headerName: 'Área',
              field: 'areaComponente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'tipoAveria',
              headerName: 'Tipo Avería',
              field: 'tipoAveria',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'severidad',
              headerName: 'Severidad',
              field: 'severidad',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'observacion',
              headerName: 'Observaciones',
              field: 'observacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'codificacion',
              headerName: 'Codificación',
              field: 'codificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'fechaAlta',
              headerName: 'Fecha Avería',
              field: 'fechaAlta',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
          ];
          break;
        case 7: //este da error
          this.columnDefinitionsConsultas = [
			      actions[0],
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'proceso',
              headerName: 'Proceso',
              field: 'proceso',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
            },
            {
              //id: 'responsable',
              headerName: 'Responsable',
              field: 'responsable',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'clasificacion',
              headerName: 'Clasificación',
              field: 'clasificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'areaComponente',
              headerName: 'Área',
              field: 'areaComponente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'tipoAveria',
              headerName: 'Tipo Avería',
              field: 'tipoAveria',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'severidad',
              headerName: 'Severidad',
              field: 'severidad',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'observacion',
              headerName: 'Observaciones',
              field: 'observacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'receptor',
              headerName: 'Receptor',
              field: 'receptor',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'cedente',
              headerName: 'Cedente',
              field: 'cedente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'fechaAlta',
              headerName: 'Fecha Avería',
              field: 'fechaAlta',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'codificacion',
              headerName: 'Codificación',
              field: 'codificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
          ];
          break;
        case 8:
          this.columnDefinitionsConsultas = [
			actions[0],
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'proceso',
              headerName: 'Proceso',
              field: 'proceso',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
            },
            {
              //id: 'responsable',
              headerName: 'Responsable',
              field: 'responsable',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'clasificacion',
              headerName: 'Clasificación',
              field: 'clasificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'areaComponente',
              headerName: 'Área',
              field: 'areaComponente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'tipoAveria',
              headerName: 'Tipo Avería',
              field: 'tipoAveria',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'severidad',
              headerName: 'Severidad',
              field: 'severidad',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'observacion',
              headerName: 'Observaciones',
              field: 'observacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'receptor',
              headerName: 'Receptor',
              field: 'receptor',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'cedente',
              headerName: 'Cedente',
              field: 'cedente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'fechaAlta',
              headerName: 'Fecha Avería',
              field: 'fechaAlta',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'codificacion',
              headerName: 'Codificación',
              field: 'codificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
          ];
          break;
        case 9:
          this.columnDefinitionsConsultas = [
              GrillaColumns.getExpandColumn(this.filasExpandidas,this),
              GrillaColumns.getDetalleColumn(),
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'fechaInspeccion',
              headerName: 'Fecha Inspeccion',
              field: 'fechaInspeccion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'proceso',
              headerName: 'Proceso',
              field: 'proceso',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'cedente',
              headerName: 'Cedente',
              field: 'cedente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'receptor',
              headerName: 'Receptor',
              field: 'receptor',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'identificador',
              headerName: 'Identificador',
              field: 'identificador',
              sortable: true,
              filter: true, floatingFilter: true,
               minWidth: 150,
              width: 110,
            },
            {
              //id: 'averia',
              headerName: 'Averias',
              field: 'averia',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
              width: 90,
            },
          ];
          break;
        case 10:
          this.columnDefinitionsConsultas = [
            GrillaColumns.getExpandColumn(this.filasExpandidas,this),
            GrillaColumns.getDetalleColumn(),
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'fechaInspeccion',
              headerName: 'Fecha Inspeccion',
              field: 'fechaInspeccion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'proceso',
              headerName: 'Proceso',
              field: 'proceso',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'cedente',
              headerName: 'Cedente',
              field: 'cedente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'receptor',
              headerName: 'Receptor',
              field: 'receptor',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'identificador',
              headerName: 'Identificador',
              field: 'identificador',
              sortable: true,
              filter: true, floatingFilter: true,
               minWidth: 150,
              width: 110,
            },
            {
              //id: 'averia',
              headerName: 'Averias',
              field: 'averia',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
              width: 90,
            },
          ];
          break;
        case 11:
          this.columnDefinitionsConsultas = [
			actions[0],
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'proceso',
              headerName: 'Proceso',
              field: 'proceso',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
            },
            {
              //id: 'tipoResponsable',
              headerName: 'Tipo Responsable',
              field: 'tipoResponsable',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 130,
            },
            {
              //id: 'clasificacion',
              headerName: 'Clasificación',
              field: 'clasificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'areaComponente',
              headerName: 'Área',
              field: 'areaComponente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'tipoAveria',
              headerName: 'Tipo Avería',
              field: 'tipoAveria',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'severidad',
              headerName: 'Severidad',
              field: 'severidad',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'observacion',
              headerName: 'Observaciones',
              field: 'observacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'receptor',
              headerName: 'Receptor',
              field: 'receptor',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'cedente',
              headerName: 'Cedente',
              field: 'cedente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'fecha',
              headerName: 'Fecha',
              field: 'fecha',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'codificacion',
              headerName: 'Codificación',
              field: 'codificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'estadoAveria',
              headerName: 'Estado',
              field: 'estadoAveria',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'comentarioAveria',
              headerName: 'Comentario del Estado',
              field: 'comentarioAveria',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
          ];
          break;
        case 12:
          this.columnDefinitionsConsultas = [
			actions[0],	
			{
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'proceso',
              headerName: 'Proceso',
              field: 'proceso',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
            },
            {
              //id: 'tipoResponsable',
              headerName: 'Tipo Responsable',
              field: 'tipoResponsable',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 130,
            },
            {
              //id: 'clasificacion',
              headerName: 'Clasificación',
              field: 'clasificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'areaComponente',
              headerName: 'Área',
              field: 'areaComponente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'tipoAveria',
              headerName: 'Tipo Avería',
              field: 'tipoAveria',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'severidad',
              headerName: 'Severidad',
              field: 'severidad',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'observacion',
              headerName: 'Observaciones',
              field: 'observacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'receptor',
              headerName: 'Receptor',
              field: 'receptor',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'cedente',
              headerName: 'Cedente',
              field: 'cedente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'fecha',
              headerName: 'Fecha',
              field: 'fecha',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'codificacion',
              headerName: 'Codificación',
              field: 'codificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
          ];
          break;
        case 14:
          this.columnDefinitionsConsultas = [
			actions[0],
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'proceso',
              headerName: 'Proceso',
              field: 'proceso',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
            },
            {
              //id: 'clasificacion',
              headerName: 'Clasificación',
              field: 'clasificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'areaComponente',
              headerName: 'Área',
              field: 'areaComponente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'tipoAveria',
              headerName: 'Tipo Avería',
              field: 'tipoAveria',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'severidad',
              headerName: 'Severidad',
              field: 'severidad',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'observacion',
              headerName: 'Observaciones',
              field: 'observacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            // { //id: 'receptor', headerName: 'Receptor', field: 'receptor', sortable: true, filter: true, floatingFilter: true, minWidth: 100},
            // { //id: 'cedente', headerName: 'Cedente', field: 'cedente', sortable: true, filter: true, floatingFilter: true, minWidth: 100},
            {
              //id: 'fecha',
              headerName: 'Fecha',
              field: 'fecha',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'codificacion',
              headerName: 'Codificación',
              field: 'codificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
          ];
          break;
        case 15:
          this.columnDefinitionsConsultas = [
			actions[0],
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'proceso',
              headerName: 'Proceso',
              field: 'proceso',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
            },
            // { //id: 'tipoResponsable', headerName: 'Tipo Responsable', field: 'tipoResponsable', sortable: true, filter: true, floatingFilter: true, minWidth: 130},
            {
              //id: 'clasificacion',
              headerName: 'Clasificación',
              field: 'clasificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'areaComponente',
              headerName: 'Área',
              field: 'areaComponente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'tipoAveria',
              headerName: 'Tipo Avería',
              field: 'tipoAveria',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'severidad',
              headerName: 'Severidad',
              field: 'severidad',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'observacion',
              headerName: 'Observaciones',
              field: 'observacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'receptor',
              headerName: 'Receptor',
              field: 'receptor',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'cedente',
              headerName: 'Cedente',
              field: 'cedente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'identificador',
              headerName: 'Identificador',
              field: 'identificador',
              sortable: true,
              filter: true, floatingFilter: true,
               minWidth: 150,
              width: 110,
            },
            {
              //id: 'comentarioDiscrepancia',
              headerName: 'Comentario Discrepancia',
              field: 'comentarioDiscrepancia',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 180,
            },
            {
              //id: 'usuarioDiscrepancia',
              headerName: 'Usuario Cedente',
              field: 'usuarioDiscrepancia',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'fecha',
              headerName: 'Fecha',
              field: 'fecha',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'codificacion',
              headerName: 'Codificación',
              field: 'codificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
          ];
          break;
        case 17:
          this.columnDefinitionsConsultas = [
              GrillaColumns.getExpandColumn(this.filasExpandidas,this),
              GrillaColumns.getDetalleColumn(),
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'fechaInspeccion',
              headerName: 'Fecha Inspeccion',
              field: 'fechaInspeccion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'proceso',
              headerName: 'Proceso',
              field: 'proceso',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'cedente',
              headerName: 'Cedente',
              field: 'cedente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'receptor',
              headerName: 'Receptor',
              field: 'receptor',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'identificador',
              headerName: 'Identificador',
              field: 'identificador',
              sortable: true,
              filter: true, floatingFilter: true,
               minWidth: 150,
              width: 110,
            },
            {
              //id: 'averia',
              headerName: 'Averias',
              field: 'averia',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
              width: 90,
            },
          ];
          break;
        case 18:
          this.columnDefinitionsConsultas = [
              GrillaColumns.getExpandColumn(this.filasExpandidas,this),
              GrillaColumns.getDetalleColumn(),
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'fechaInspeccion',
              headerName: 'Fecha Inspeccion',
              field: 'fechaInspeccion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'proceso',
              headerName: 'Proceso',
              field: 'proceso',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'cedente',
              headerName: 'Cedente',
              field: 'cedente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'receptor',
              headerName: 'Receptor',
              field: 'receptor',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'identificador',
              headerName: 'Identificador',
              field: 'identificador',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,
              width: 110,
            },
            {
              //id: 'averia',
              headerName: 'Averias',
              field: 'averia',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
              width: 90,
            },
          ];
          break;
        case 16:
          this.columnDefinitionsConsultas = [
             GrillaColumns.getExpandColumn(this.filasExpandidas,this),
             GrillaColumns.getDetalleColumn(),
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,
              width: 150,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
              width: 190,
            },
            {
              //id: 'fechaInspeccion',
              headerName: 'Fecha Inspeccion',
              field: 'fechaInspeccion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,
              width: 150,
            },
            {
              //id: 'proceso',
              headerName: 'Proceso',
              field: 'proceso',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,
              width: 150,
            },
            {
              //id: 'cedente',
              headerName: 'Cedente',
              field: 'cedente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,
              width: 150,
            },
            {
              //id: 'receptor',
              headerName: 'Receptor',
              field: 'receptor',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,
              width: 150,
            },
            {
              //id: 'identificador',
              headerName: 'Identificador',
              field: 'identificador',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,
              width: 110,
            },
            {
              //id: 'averia',
              headerName: 'Averias',
              field: 'averia',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
              width: 90,
            },
          ];
          break;
        case 13:
          this.columnDefinitionsConsultas = [
         actions[0],
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'proceso',
              headerName: 'Proceso',
              field: 'proceso',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 90,
            },
            // { //id: 'tipoResponsable', headerName: 'Tipo Responsable', field: 'tipoResponsable', sortable: true, filter: true, floatingFilter: true, minWidth: 130},
            {
              //id: 'clasificacion',
              headerName: 'Clasificación',
              field: 'clasificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'areaComponente',
              headerName: 'Área',
              field: 'areaComponente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'tipoAveria',
              headerName: 'Tipo Avería',
              field: 'tipoAveria',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'severidad',
              headerName: 'Severidad',
              field: 'severidad',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'observacion',
              headerName: 'Observaciones',
              field: 'observacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'receptor',
              headerName: 'Receptor',
              field: 'receptor',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'cedente',
              headerName: 'Cedente',
              field: 'cedente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'fecha',
              headerName: 'Fecha',
              field: 'fecha',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'codificacion',
              headerName: 'Codificación',
              field: 'codificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
          ];
          break;
        default:
          this.columnDefinitionsConsultas = [
            {
              //id: 'modelo',
              headerName: 'Modelo',
              field: 'modelo',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
            {
              //id: 'vin',
              headerName: 'Vin',
              field: 'vin',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 190,
            },
            {
              //id: 'responsable',
              headerName: 'Responsable',
              field: 'responsable',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'clasificacion',
              headerName: 'Clasificación',
              field: 'clasificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'areaComponente',
              headerName: 'Área',
              field: 'areaComponente',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'tipoAveria',
              headerName: 'Tipo Avería',
              field: 'tipoAveria',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 150,width: 150,
            },
            {
              //id: 'severidad',
              headerName: 'Severidad',
              field: 'severidad',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 140,
            },
            {
              //id: 'codificacion',
              headerName: 'Codificación',
              field: 'codificacion',
              sortable: true,
              filter: true, floatingFilter: true,
              minWidth: 100,
            },
          ];
          break;
      }


    }
  }
}
